import { SvgIcon } from '@mui/material';

export function DashboardIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 18,
    height: 18,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      sx={rootSx}
      {...rest}
    >
      <path
        d="M8.25 6A2.261 2.261 0 006 8.25v1.5A2.261 2.261 0 008.25 12h4a2.261 2.261 0 002.25-2.25v-1.5A2.261 2.261 0 0012.25 6zm9.5 0a2.261 2.261 0 00-2.25 2.25v6.5A2.261 2.261 0 0017.75 17h4A2.261 2.261 0 0024 14.75v-6.5A2.261 2.261 0 0021.75 6zm-9.5 1.5h4a.739.739 0 01.75.75v1.5a.739.739 0 01-.75.75h-4a.739.739 0 01-.75-.75v-1.5a.739.739 0 01.75-.75zm9.5 0h4a.739.739 0 01.75.75v6.5a.739.739 0 01-.75.75h-4a.739.739 0 01-.75-.75v-6.5a.739.739 0 01.75-.75zM8.25 13A2.261 2.261 0 006 15.25v6.5A2.261 2.261 0 008.25 24h4a2.261 2.261 0 002.25-2.25v-6.5A2.261 2.261 0 0012.25 13zm0 1.5h4a.739.739 0 01.75.75v6.5a.739.739 0 01-.75.75h-4a.739.739 0 01-.75-.75v-6.5a.739.739 0 01.75-.75zm9.5 3.5a2.261 2.261 0 00-2.25 2.25v1.5A2.261 2.261 0 0017.75 24h4A2.261 2.261 0 0024 21.75v-1.5A2.261 2.261 0 0021.75 18zm0 1.5h4a.739.739 0 01.75.75v1.5a.739.739 0 01-.75.75h-4a.739.739 0 01-.75-.75v-1.5a.739.739 0 01.75-.75z"
        transform="translate(-6 -6)"
        fill="#0e1824"
      />
    </SvgIcon>
  );
}

export function ParameterSetupIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 18,
    height: 18,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 14.271 12"
      {...rest}
    >
      <path
        data-name="Parameter setup"
        d="M12.019 2a2.088 2.088 0 00-.807.11.2.2 0 00-.073.324l1.022 1.026a.676.676 0 01.063.908.649.649 0 01-.952.037l-1.05-1.05a.2.2 0 00-.324.073 2.1 2.1 0 002.627 2.689L14.61 8.2a.973.973 0 101.376-1.376L13.9 4.741a2.1 2.1 0 00-1.594-2.7A2.2 2.2 0 0012.019 2zM4.432 4.27A1.136 1.136 0 003.3 5.406v6.162A1.136 1.136 0 004.432 12.7h9.406a1.136 1.136 0 001.135-1.135V9.1a1.61 1.61 0 01-.822-.442L14 8.509v3.058a.163.163 0 01-.162.162H4.432a.163.163 0 01-.162-.162V5.406a.163.163 0 01.162-.162h4.956a2.642 2.642 0 01-.2-.6 2.839 2.839 0 01-.046-.376zm-1.946 8.757a.487.487 0 100 .973h13.3a.487.487 0 100-.973z"
        transform="translate(-2 -2)"
        fill="#0e1824"
      />
    </SvgIcon>
  );
}

export function AwrShareIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 32,
    height: 32,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      sx={rootSx}
      {...rest}
    >
      <g id="Share" transform="translate(-4 -4)">
        <circle
          id="Ellipse_39211"
          data-name="Ellipse 39211"
          cx="16"
          cy="16"
          r="16"
          transform="translate(4 4)"
          fill="#f0f0f0"
        />
        <path
          id="icons8-share"
          d="M15.823,5.984a.5.5,0,0,0-.348.858l.813.813h-.459a7.171,7.171,0,0,0-7.163,7.164.5.5,0,1,0,1,0,6.156,6.156,0,0,1,6.163-6.164h.459l-.813.813a.5.5,0,1,0,.707.707L17.8,8.552a.5.5,0,0,0,0-.8l-1.62-1.62a.5.5,0,0,0-.359-.152ZM8.166,5.99A2.173,2.173,0,0,0,6,8.155v7.663a2.173,2.173,0,0,0,2.166,2.166h7.663a2.173,2.173,0,0,0,2.166-2.166V13.153a.5.5,0,1,0-1,0v2.666a1.159,1.159,0,0,1-1.166,1.166H8.166A1.159,1.159,0,0,1,7,15.819V8.155A1.159,1.159,0,0,1,8.166,6.989h2.665a.5.5,0,0,0,0-1Z"
          transform="translate(8 8.016)"
          fill="#007965"
        />
      </g>
    </SvgIcon>
  );
}

export function FeedBackandBugIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 18,
    height: 18,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 15.781 15.781"
      {...rest}
    >
      <path
        d="M11.891 4a7.891 7.891 0 107.891 7.891A7.9 7.9 0 0011.891 4zm0 1.184a6.707 6.707 0 11-6.707 6.707 6.7 6.7 0 016.707-6.707zm1.13 2.762a1.832 1.832 0 00-.432.054l-3.281.8a1.187 1.187 0 00-.88.924l-.174.9a.967.967 0 00.6 1.088l.2.078a2.765 2.765 0 011.332 1.086l1.234 1.93a.3.3 0 01.038.083q.162.557.228.791c.018.063.034.127.065.245.1.378.185.7.544.7.5 0 1.078-.417 1.078-1.591a6.626 6.626 0 00-.4-1.85h1.078a1.182 1.182 0 001.149-1.476l-.609-2.386a1.835 1.835 0 00-1.77-1.377z"
        transform="translate(-4 -4)"
        fill="#0e1824"
      />
    </SvgIcon>
  );
}

export function ForwardIconAlt(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 20,
    height: 20,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 20 20"
      {...rest}
    >
      <g data-name="Group 121209" transform="translate(-4 -4)">
        <circle
          data-name="Ellipse 39211"
          cx={10}
          cy={10}
          r={10}
          transform="translate(4 4)"
          fill="#239179"
        />
        <path
          d="M11.889 10.525l3.49 3.49-3.49 3.49a.4.4 0 00.561.561l3.77-3.77a.4.4 0 000-.561l-3.77-3.771a.4.4 0 00-.561.561z"
          fill="#239179"
          stroke="#fff"
          strokeWidth={1}
        />
      </g>
    </SvgIcon>
  );
}

export function AwrVideoIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 16,
    height: 16,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 16 16"
      {...rest}
    >
      <path
        id="icons8-video"
        d="M12,4a8,8,0,1,0,8,8A8.009,8.009,0,0,0,12,4Zm0,1.2A6.8,6.8,0,1,1,5.2,12,6.791,6.791,0,0,1,12,5.2ZM10.166,8.471a1.024,1.024,0,0,0-.966.991v5.075a1.019,1.019,0,0,0,1.466.885h0l4.821-2.538h0a1.022,1.022,0,0,0,0-1.77h0L10.666,8.577A.942.942,0,0,0,10.166,8.471ZM10.4,9.793,14.592,12,10.4,14.206Z"
        transform="translate(-4 -4)"
        fill="#666"
      />
    </SvgIcon>
  );
}

export function AwrImgIcon(props) {
  const { rootStyle, fill, ...rest } = props;
  const rootSx = {
    width: 16,
    height: 16,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 16 16"
      {...rest}
    >
      <path
        id="icons8-image"
        d="M8.444,6A2.455,2.455,0,0,0,6,8.444V19.556A2.455,2.455,0,0,0,8.444,22H19.556A2.455,2.455,0,0,0,22,19.556V8.444A2.455,2.455,0,0,0,19.556,6Zm0,1.333H19.556a1.1,1.1,0,0,1,1.111,1.111v9.091l-2.672-2.585h0a1.8,1.8,0,0,0-2.5,0l-.911.881-2.747-2.657a1.795,1.795,0,0,0-2.5,0h0l-2,1.937V8.444A1.1,1.1,0,0,1,8.444,7.333Zm8.444,1.778a2,2,0,0,0-1.5.641,2.092,2.092,0,0,0,0,2.719,2.072,2.072,0,0,0,3,0,2.092,2.092,0,0,0,0-2.719A2,2,0,0,0,16.889,9.111Zm0,1.333a.587.587,0,0,1,.5.193.763.763,0,0,1,0,.948.75.75,0,0,1-1,0,.763.763,0,0,1,0-.948A.587.587,0,0,1,16.889,10.444ZM10.586,14a.457.457,0,0,1,.323.132h0l2.714,2.626-4.04,3.908H8.444a1.1,1.1,0,0,1-1.111-1.111V16.966l2.929-2.833A.459.459,0,0,1,10.586,14Zm6.158,1.778a.456.456,0,0,1,.324.131l3.6,3.482v.165a1.1,1.1,0,0,1-1.111,1.111H11.5l4.918-4.758A.457.457,0,0,1,16.744,15.778Z"
        transform="translate(-6 -6)"
        fill={fill}
      />
    </SvgIcon>
  );
}

export function ForwardIconBtn(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 20,
    height: 20,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 20 20"
      {...rest}
    >
      <g data-name="Group 121209" transform="translate(-4 -4)">
        <circle
          data-name="Ellipse 39211"
          cx={10}
          cy={10}
          r={10}
          transform="translate(4 4)"
          fill="#fff"
        />
        <path
          d="M11.889 10.525l3.49 3.49-3.49 3.49a.4.4 0 00.561.561l3.77-3.77a.4.4 0 000-.561l-3.77-3.771a.4.4 0 00-.561.561z"
          fill="#239179"
          stroke="#239179"
          strokeWidth={1}
        />
      </g>
    </SvgIcon>
  );
}

export function ArrowwithCircle(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 20,
    height: 20,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 24 24"
      {...rest}
    >
      <g data-name="Group 122025" stroke="#5c6266" strokeWidth={0.5}>
        <g
          data-name="Ellipse 39211"
          transform="translate(-1 2) translate(1 -2)"
          fill="#fff"
        >
          <circle cx={12} cy={12} r={12} stroke="none" />
          <circle cx={12} cy={12} r={11.75} fill="none" />
        </g>
        <path
          d="M10.797 6.451L14.346 10l-3.549 3.549a.404.404 0 00.571.571l3.834-3.835a.4.4 0 000-.571L11.368 5.88a.404.404 0 00-.571.571z"
          fill="#5c6266"
          transform="translate(-1 2)"
        />
      </g>
    </SvgIcon>
  );
}

export function ChatBotChatIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 20,
    height: 20,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      sx={rootSx}
      {...rest}
    >
      <path
        fill="#6EBDAB"
        d="M3.002,24.999c0-0.596,0-3.403,0-4c0-1.104,0.896-2,2-2h4	v7.999l-4,0.001C3.898,26.999,3.002,26.103,3.002,24.999z"
      />
      <path fill="#6EBDAB" d="M23.001,3.999v6.999h2.001V3.999H23.001z" />
      <linearGradient
        id="fCPFqMkqUQaT0iA7GuHGYa"
        x1="-253.5"
        x2="-253.5"
        y1="-41.668"
        y2="-34.167"
        gradientTransform="translate(277.502 42.001)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#21ad64" />
        <stop offset="1" stop-color="#088242" />
      </linearGradient>
      <path
        fill="url(#fCPFqMkqUQaT0iA7GuHGYa)"
        d="M24.002,0.999c1.653,0,3,1.347,3,3	c0,1.653-1.347,3-3,3c-1.653,0-3-1.347-3-3C21.002,2.346,22.349,0.999,24.002,0.999z"
      />
      <path
        fill="#6EBDAB"
        d="M45.002,24.999c0-0.596,0-3.403,0-4c0-1.104-0.896-2-2-2h-4	v7.999l4,0.001C44.106,26.999,45.002,26.103,45.002,24.999z"
      />
      <linearGradient
        id="fCPFqMkqUQaT0iA7GuHGYb"
        x1="-256.774"
        x2="-233.881"
        y1="-40.58"
        y2="-3.333"
        gradientTransform="translate(269.016 44.445)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#21ad64" />
        <stop offset="1" stop-color="#088242" />
      </linearGradient>
      <path
        fill="#6EBDAB"
        d="M40.001,8.998H8.002c-1.105,0-2,0.896-2,2v24	c0,1.104,0.895,2,2,2h8v7.997c0,0.891,1.076,1.337,1.707,0.707l8.704-8.704h13.588c1.104,0,2-0.896,2-2v-24	C42.001,9.894,41.105,8.998,40.001,8.998z"
      />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M17.502,17.002	c1.379,0,2.499,1.12,2.499,2.499c0,1.379-1.12,2.499-2.499,2.499c-1.379,0-2.499-1.12-2.499-2.499	C15.003,18.122,16.123,17.002,17.502,17.002z"
        clip-rule="evenodd"
      />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M30.501,17.002	c-1.379,0-2.499,1.12-2.499,2.499c0,1.379,1.12,2.499,2.499,2.499c1.379,0,2.499-1.12,2.499-2.499	C32.999,18.122,31.879,17.002,30.501,17.002z"
        clip-rule="evenodd"
      />
      <path
        fill="#fff"
        d="M17.002,26.999c0,0.459,2.8,4,7,4c4.2,0,7-3.541,7-4	c0-0.461-0.613-1-1-1c-0.063,0-2.88,2-6,2c-3.115,0-5.931-2-6-2C17.615,25.999,17.002,26.538,17.002,26.999z"
      />
    </SvgIcon>
  );
}

export function MessageSendIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 18,
    height: 18,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      sx={rootSx}
      {...rest}
    >
      <path
        // class="cls-1"
        d="M2.33,44.58,117.33.37a3.63,3.63,0,0,1,5,4.56l-44,115.61h0a3.63,3.63,0,0,1-6.67.28L53.93,84.14,89.12,33.77,38.85,68.86,2.06,51.24a3.63,3.63,0,0,1,.27-6.66Z"
      />
    </SvgIcon>
  );
}

export function ChatBotLeftArrowSVG(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 10,
    height: 14,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10 14"
      sx={rootSx}
      {...rest}
    >
      <path
        d="M9.91075 0.0780067V0H10V14H9.91075V13.923L0.98378 8.75401C0.685924 8.58159 0.437459 8.32787 0.264389 8.01938C0.0913189 7.7109 0 7.359 0 7.00051C0 6.64202 0.0913189 6.29012 0.264389 5.98163C0.437459 5.67315 0.685924 5.41942 0.98378 5.24701L9.91075 0.0780067Z"
        fill="#F2F2F2"
      />
    </SvgIcon>
  );
}

export function ChatBotRightArrowSVG(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 10,
    height: 14,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10 14"
      sx={rootSx}
      {...rest}
    >
      <path
        d="M0.0892492 13.922V14H5.96046e-07L5.96046e-07 8.34465e-07H0.0892492V0.0769929L9.01622 5.24599C9.31408 5.41841 9.56254 5.67213 9.73561 5.98062C9.90868 6.2891 10 6.641 10 6.99949C10 7.35798 9.90868 7.70989 9.73561 8.01837C9.56254 8.32685 9.31408 8.58058 9.01622 8.75299L0.0892492 13.922Z"
        fill="#5D9DEF"
      />
    </SvgIcon>
  );
}

export function FilterSortIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 18.536,
    height: 16,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18.536 16"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-sort"
        d="M6.833,5a.632.632,0,0,0-.437.185L2.185,9.4a.632.632,0,1,0,.893.893L6.21,7.156v9a.632.632,0,1,0,1.263,0v-9l3.132,3.132A.632.632,0,1,0,11.5,9.4L7.289,5.185A.632.632,0,0,0,6.833,5Zm8.851,0a.632.632,0,1,0,.632.632A.632.632,0,0,0,15.684,5Zm0,2.105a.632.632,0,1,0,.632.632A.632.632,0,0,0,15.684,7.105Zm-.01,2.1a.632.632,0,0,0-.622.641v8.581L11.92,15.29a.632.632,0,1,0-.893.893l4.211,4.211a.632.632,0,0,0,.893,0l4.211-4.211a.632.632,0,1,0-.893-.893l-3.132,3.132V9.842a.632.632,0,0,0-.641-.641Zm-8.832,8.43a.632.632,0,1,0,.632.632A.632.632,0,0,0,6.842,17.631Zm0,2.105a.632.632,0,1,0,.632.632A.632.632,0,0,0,6.842,19.737Z"
        transform="translate(-2 -5)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function SetAvailabilityIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    color: '#007965',
    width: 16,
    height: 16,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-calendar"
        d="M8.889,6A2.9,2.9,0,0,0,6,8.889V19.111A2.9,2.9,0,0,0,8.889,22H19.111A2.9,2.9,0,0,0,22,19.111V8.889A2.9,2.9,0,0,0,19.111,6Zm0,1.333H19.111a1.546,1.546,0,0,1,1.556,1.556v.667H7.333V8.889A1.546,1.546,0,0,1,8.889,7.333ZM7.333,10.889H20.667v8.222a1.546,1.546,0,0,1-1.556,1.556H8.889a1.546,1.546,0,0,1-1.556-1.556Zm2.889,1.778a1.111,1.111,0,1,0,1.111,1.111,1.111,1.111,0,0,0-1.111-1.111Zm3.778,0a1.111,1.111,0,1,0,1.111,1.111A1.111,1.111,0,0,0,14,12.667Zm3.778,0a1.111,1.111,0,1,0,1.111,1.111A1.111,1.111,0,0,0,17.778,12.667Zm-7.556,4a1.111,1.111,0,1,0,1.111,1.111A1.111,1.111,0,0,0,10.222,16.667Zm3.778,0a1.111,1.111,0,1,0,1.111,1.111A1.111,1.111,0,0,0,14,16.667Z"
        transform="translate(-6 -6)"
        fill="#0e1824"
      />
    </SvgIcon>
  );
}

export function TransectionsIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    color: '#007965',
    width: 16,
    height: 12.571,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 12.571"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-ledger"
        d="M4.714,8A1.723,1.723,0,0,0,3,9.714v7.238a1.664,1.664,0,0,0,.022.217A.571.571,0,0,0,3,17.333v1.524a1.723,1.723,0,0,0,1.714,1.714H17.286A1.723,1.723,0,0,0,19,18.857V17.333a.572.572,0,0,0-.022-.164A1.667,1.667,0,0,0,19,16.952V9.714A1.723,1.723,0,0,0,17.286,8H12.9a2.437,2.437,0,0,0-1.9.959A2.437,2.437,0,0,0,9.1,8Zm0,1.143H9.1a1.325,1.325,0,0,1,1.333,1.333v7.665a3.3,3.3,0,0,0-1.894-.618H4.714a.563.563,0,0,1-.571-.571V9.714A.563.563,0,0,1,4.714,9.143Zm8.19,0h4.381a.563.563,0,0,1,.571.571v7.238a.563.563,0,0,1-.571.571h-3.82a3.3,3.3,0,0,0-1.894.618V10.476A1.325,1.325,0,0,1,12.9,9.143ZM14.81,9.9a.571.571,0,0,0-.571.571v.254a1.615,1.615,0,0,0-1.15,2.048A1.7,1.7,0,0,0,14.717,13.9H15.1a.476.476,0,1,1,0,.952h-.652a.492.492,0,0,1-.456-.256.574.574,0,0,0-.862-.2.588.588,0,0,0-.14.748,1.628,1.628,0,0,0,1.252.833v.205a.571.571,0,1,0,1.143,0v-.22A1.618,1.618,0,0,0,16.7,14.186a1.671,1.671,0,0,0-1.684-1.424h-.392a.477.477,0,0,1-.476-.476.508.508,0,0,1,.513-.476h.322a.437.437,0,0,1,.456.256.572.572,0,0,0,.858.2.6.6,0,0,0,.143-.752,1.532,1.532,0,0,0-1.061-.8v-.234A.571.571,0,0,0,14.81,9.9Zm-8.953.381a.571.571,0,1,0,0,1.143H8.524a.571.571,0,1,0,0-1.143Zm0,2.286a.571.571,0,1,0,0,1.143H8.524a.571.571,0,1,0,0-1.143Zm0,2.286a.571.571,0,1,0,0,1.143H7a.571.571,0,1,0,0-1.143Zm-1.714,3.7a1.679,1.679,0,0,0,.571.106h3.82a2.168,2.168,0,0,1,1.645.762H4.714a.563.563,0,0,1-.571-.571Zm13.714,0v.3a.563.563,0,0,1-.571.571H11.819a2.17,2.17,0,0,1,1.647-.762h3.82A1.679,1.679,0,0,0,17.857,18.56Z"
        transform="translate(-3 -8)"
        fill="#0e1824"
      />
    </SvgIcon>
  );
}

export function FooterShareIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    color: '#007965',
    width: 18.25,
    height: 18.25,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18.25 18.25"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-connect"
        d="M19.684,5a3.31,3.31,0,0,0-2.565,5.41l-2.28,2.879H11.553a3.316,3.316,0,1,0,0,1.421H14.84l2.28,2.879a3.349,3.349,0,1,0,1.115-.881L16.091,14l2.144-2.709a3.277,3.277,0,0,0,1.45.34,3.316,3.316,0,0,0,0-6.632Zm0,1.421a1.895,1.895,0,1,1-1.895,1.895A1.884,1.884,0,0,1,19.684,6.421ZM8.316,12.105A1.895,1.895,0,1,1,6.421,14,1.884,1.884,0,0,1,8.316,12.105Zm11.368,5.684a1.895,1.895,0,1,1-1.895,1.895A1.884,1.884,0,0,1,19.684,17.789Z"
        transform="translate(-4.875 -4.875)"
        fill="currentColor"
        stroke="#5c6066"
      />
    </SvgIcon>
  );
}

export function FooterPatientIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    color: '#007965',
    width: 24,
    height: 24,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      sx={rootSx}
      {...rest}
    >
      <g
        id="Group_106492"
        data-name="Group 106492"
        transform="translate(21445 18714)"
      >
        <rect
          id="Rectangle_56261"
          data-name="Rectangle 56261"
          width="24"
          height="24"
          transform="translate(-21445 -18714)"
          fill="none"
        />
        <path
          id="icons8-health-checkup"
          d="M16.165,1.914a3.092,3.092,0,1,0,3.092,3.092A3.1,3.1,0,0,0,16.165,1.914Zm0,1.325A1.767,1.767,0,1,1,14.4,5.006,1.757,1.757,0,0,1,16.165,3.239ZM3.884,4.161a1.1,1.1,0,0,0-.942.53A2.611,2.611,0,0,0,1.478,8.662L5.43,14.308s0,.008,0,.012v.442a5.732,5.732,0,0,0,8.383,5.093,4.852,4.852,0,0,0,7.21-4.247V10.632a1.661,1.661,0,0,0-1.65-1.65H12.955a1.66,1.66,0,0,0-1.649,1.65v4.975a4.836,4.836,0,0,0,1.325,3.322,4.413,4.413,0,0,1-5.876-4.168V14.32q0-.011,0-.022l3.71-5.708A2.613,2.613,0,0,0,9.309,4.814,1.105,1.105,0,1,0,9,6.121a1.231,1.231,0,0,1,.356,1.746L6.072,12.914,2.564,7.9a1.228,1.228,0,0,1,.52-1.877,1.1,1.1,0,1,0,.8-1.864Zm9.071,6.146h6.418a.316.316,0,0,1,.325.325v4.975a3.535,3.535,0,0,1-4.631,3.359,5.722,5.722,0,0,0,1.847-4.2V13.214a1.1,1.1,0,1,0-1.325,0v1.547a4.4,4.4,0,0,1-1.743,3.514,3.52,3.52,0,0,1-1.216-2.668V10.632A.315.315,0,0,1,12.955,10.306Z"
          transform="translate(-21444.023 -18713.209)"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
}

export function FooterProfileIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    color: '#007965',
    width: 24,
    height: 24,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      sx={rootSx}
      {...rest}
    >
      <g
        id="Group_5573"
        data-name="Group 5573"
        transform="translate(-373 -5349)"
      >
        <circle
          id="Ellipse_39469"
          data-name="Ellipse 39469"
          cx="12"
          cy="12"
          r="12"
          transform="translate(373 5349)"
          fill="none"
        />
        <path
          id="Doctor_Profile"
          data-name="Doctor Profile"
          d="M15.2,4a4.5,4.5,0,1,0,4.5,4.5A4.51,4.51,0,0,0,15.2,4Zm0,1.35A3.15,3.15,0,1,1,12.05,8.5,3.14,3.14,0,0,1,15.2,5.35ZM9.79,14.8A1.8,1.8,0,0,0,8,16.59v.685A4.194,4.194,0,0,0,10.388,20.9,10.128,10.128,0,0,0,15.2,22a10.128,10.128,0,0,0,4.812-1.1,4.35,4.35,0,0,0,2.281-2.953H22.4V16.59A1.8,1.8,0,0,0,20.61,14.8Zm0,1.35H20.61a.431.431,0,0,1,.441.44v.01h0v.675a2.742,2.742,0,0,1-1.69,2.447,8.97,8.97,0,0,1-4.16.928,8.97,8.97,0,0,1-4.16-.928,2.742,2.742,0,0,1-1.69-2.447V16.59A.43.43,0,0,1,9.79,16.15Z"
          transform="translate(369.799 5348)"
          fill="currentColor"
          stroke="currentColor"
        />
      </g>
    </SvgIcon>
  );
}

export function SqureCheckedIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 24,
    height: 24,
    color: '#6552cc',
    ...rootStyle,
  };
  return (
    <SvgIcon
      data-name="Component 206 \u2013 14"
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 24 24"
      {...rest}
    >
      <path data-name="Rectangle 55884" fill="none" d="M0 0H24V24H0z" />
      <path
        d="M19.556 6H8.444A2.448 2.448 0 006 8.444v11.112A2.448 2.448 0 008.444 22h11.112A2.448 2.448 0 0022 19.556V8.444A2.448 2.448 0 0019.556 6zm-.417 5.583L12.916 17.8a.667.667 0 01-.943 0l-2.667-2.662a.667.667 0 11.943-.943l2.2 2.2 5.751-5.751a.667.667 0 01.944.943z"
        transform="translate(-2 -2)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function SquareCheckBoxIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 24,
    height: 24,
    ...rootStyle,
  };
  return (
    <SvgIcon
      data-name="Component 206 \u2013 14"
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 24 24"
      {...rest}
    >
      <path data-name="Rectangle 55884" fill="none" d="M0 0H24V24H0z" />
      <path
        d="M8.667 6A2.68 2.68 0 006 8.667v10.666A2.68 2.68 0 008.667 22h10.666A2.68 2.68 0 0022 19.333V8.667A2.68 2.68 0 0019.333 6zm0 1.778h10.666a.876.876 0 01.889.889v10.666a.876.876 0 01-.889.889H8.667a.876.876 0 01-.889-.889V8.667a.876.876 0 01.889-.889z"
        transform="translate(-2 -2)"
        fill="#241f46"
      />
    </SvgIcon>
  );
}
export function CautionIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 24,
    height: 24,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 21.624 20"
      {...rest}
    >
      <path
        d="M25.313 21.375L16.944 6.258a2.44 2.44 0 00-4.269 0L4.306 21.375A2.442 2.442 0 006.441 25h16.737a2.442 2.442 0 002.135-3.625zM14 11.757a.811.811 0 011.622 0v5.405a.811.811 0 01-1.622 0zm.811 10a1.081 1.081 0 111.081-1.081 1.081 1.081 0 01-1.082 1.081z"
        transform="translate(-3.997 -5)"
        fill="#feaf45"
      />
    </SvgIcon>
  );
}

export function AddNotesIcone(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 44,
    height: 44,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={44}
      height={44}
      sx={rootSx}
      viewBox="0 0 44 44"
      {...rest}
    >
      <g data-name="Group 106224" transform="translate(-48 -479)">
        <rect
          data-name="Rectangle 46375"
          width={44}
          height={44}
          rx={22}
          transform="translate(48 479)"
          fill="#e9f0ef"
        />
        <path
          d="M8.5 6A2.513 2.513 0 006 8.5v15A2.513 2.513 0 008.5 26h10.556a.833.833 0 00.589-.244l.009-.009 6.1-6.1a.833.833 0 00.246-.591V8.5A2.513 2.513 0 0023.5 6zm0 1.667h15a.821.821 0 01.833.833v9.722h-3.611a2.513 2.513 0 00-2.5 2.5v3.611H8.5a.821.821 0 01-.833-.833v-15a.821.821 0 01.833-.833zm2.778 2.777a.833.833 0 100 1.667h9.444a.833.833 0 100-1.667zm0 3.889a.833.833 0 100 1.667H18.5a.833.833 0 100-1.667zm9.444 5.557h2.433l-3.266 3.266v-2.434a.821.821 0 01.833-.833z"
          transform="translate(54 485)"
          fill="#5c6266"
        />
        <g data-name="Group 106352" transform="translate(3 -28)">
          <circle
            data-name="Ellipse 129853"
            cx={8}
            cy={8}
            r={8}
            transform="translate(73 507)"
            fill="#007965"
          />
          <path
            d="M80.962 510.999a.316.316 0 00-.311.32v3.367h-3.368a.316.316 0 100 .631h3.368v3.366a.316.316 0 00.632 0v-3.362h3.368a.316.316 0 100-.631h-3.368v-3.369a.316.316 0 00-.321-.32z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.5}
          />
        </g>
      </g>
    </SvgIcon>
  );
}
export function ExpertNotePad(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 11.2,
    height: 14,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 11.2 14"
      {...rest}
    >
      <path
        d="M12.375 4a1.579 1.579 0 00-1.557 1.4H9.575A1.583 1.583 0 008 6.975v9.45A1.583 1.583 0 009.575 18h8.05a1.583 1.583 0 001.575-1.575v-9.45A1.583 1.583 0 0017.625 5.4h-1.243A1.579 1.579 0 0014.825 4zm0 1.05h2.45a.525.525 0 110 1.05h-2.45a.525.525 0 110-1.05zm-2.8 1.4h1.494a1.579 1.579 0 001.306.7h2.45a1.579 1.579 0 001.306-.7h1.494a.517.517 0 01.525.525v9.45a.517.517 0 01-.525.525h-8.05a.517.517 0 01-.525-.525v-9.45a.517.517 0 01.525-.525zm1.4 3.15a.525.525 0 10.525.525.525.525 0 00-.525-.525zm2.1 0a.525.525 0 100 1.05h3.15a.525.525 0 100-1.05zm-2.1 2.1a.525.525 0 10.525.525.525.525 0 00-.525-.525zm2.1 0a.525.525 0 100 1.05h3.15a.525.525 0 100-1.05zm-2.1 2.1a.525.525 0 10.525.525.525.525 0 00-.525-.525zm2.1 0a.525.525 0 100 1.05h3.15a.525.525 0 100-1.05z"
        transform="translate(-8 -4)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function AddDontsIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 44,
    height: 44,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 44 44"
      {...rest}
    >
      <g data-name="Group 106223" transform="translate(-134 -479)">
        <rect
          data-name="Rectangle 56145"
          width={44}
          height={44}
          rx={22}
          transform="translate(134 479)"
          fill="#e9f0ef"
        />
        <path
          d="M15.636 0a2.4 2.4 0 00-2.386 2.386v.477h-3.1A2.159 2.159 0 008 5.011v13.841A2.159 2.159 0 0010.148 21h10.977a2.159 2.159 0 002.148-2.148V5.011a2.159 2.159 0 00-2.148-2.148h-3.1v-.477A2.4 2.4 0 0015.636 0zm0 1.432a.944.944 0 01.955.955V4.3h-1.909V2.386a.944.944 0 01.954-.954zM10.148 4.3h3.1v.716a.716.716 0 00.716.716h3.341a.716.716 0 00.716-.716V4.3h3.1a.705.705 0 01.716.716v13.836a.705.705 0 01-.716.716H10.148a.705.705 0 01-.716-.716V5.011a.705.705 0 01.716-.711zm5.477 3.331a.716.716 0 00-.7.726v4.773a.716.716 0 101.432 0V8.352a.716.716 0 00-.727-.726zm.011 7.647a.955.955 0 10.955.955.955.955 0 00-.955-.96z"
          transform="translate(140.364 490.5)"
          fill="#5c6266"
        />
        <g data-name="Group 106353" transform="translate(89 -28)">
          <circle
            data-name="Ellipse 129853"
            cx={8}
            cy={8}
            r={8}
            transform="translate(73 507)"
            fill="#007965"
          />
          <path
            d="M80.962 510.999a.316.316 0 00-.311.32v3.367h-3.368a.316.316 0 100 .631h3.368v3.366a.316.316 0 00.632 0v-3.362h3.368a.316.316 0 100-.631h-3.368v-3.369a.316.316 0 00-.321-.32z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.5}
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function AddReferencesIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 44,
    height: 44,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 44 44"
      {...rest}
    >
      <g data-name="Group 106222" transform="translate(-220 -479)">
        <rect
          data-name="Rectangle 56146"
          width={44}
          height={44}
          rx={22}
          transform="translate(220 479)"
          fill="#e9f0ef"
        />
        <path
          data-name="icons8-repository (1)"
          d="M10.5 3A2.51 2.51 0 008 5.5v12.725a2.5 2.5 0 002.273 2.488v-1.374a1.139 1.139 0 01-.884-.886h12.474a.682.682 0 00.682-.682V5.5a2.51 2.51 0 00-2.5-2.5zm0 1.364h9.545A1.126 1.126 0 0121.181 5.5v11.589H9.364V5.5A1.126 1.126 0 0110.5 4.362zm1.136 1.819a.909.909 0 10.909.909.909.909 0 00-.909-.911zm0 3.636a.909.909 0 10.909.909.909.909 0 00-.909-.911zm0 3.636a.909.909 0 10.909.909.909.909 0 00-.909-.911zm-.455 5.909v2.954a.682.682 0 001.164.482l.882-.881.882.881a.681.681 0 001.164-.482v-2.956zm5 0v1.364h5.681a.682.682 0 100-1.364z"
          transform="translate(226.728 488.002)"
          fill="#5c6266"
        />
        <g data-name="Group 106354" transform="translate(175 -28)">
          <circle
            data-name="Ellipse 129853"
            cx={8}
            cy={8}
            r={8}
            transform="translate(73 507)"
            fill="#007965"
          />
          <path
            d="M80.962 510.999a.316.316 0 00-.311.32v3.367h-3.368a.316.316 0 100 .631h3.368v3.366a.316.316 0 00.632 0v-3.362h3.368a.316.316 0 100-.631h-3.368v-3.369a.316.316 0 00-.321-.32z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.5}
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function RxIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 12.8,
    height: 16,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 12.8 16"
      {...rest}
    >
      <path
        id="icons8-file-prescription"
        d="M9.8,4A1.809,1.809,0,0,0,8,5.8V18.2A1.809,1.809,0,0,0,9.8,20H19a1.809,1.809,0,0,0,1.8-1.8V9.8a.6.6,0,0,0-.176-.424l-.006-.006L15.424,4.176A.6.6,0,0,0,15,4Zm0,1.2h4.6V8.6a1.809,1.809,0,0,0,1.8,1.8h3.4v7.8a.591.591,0,0,1-.6.6H9.8a.591.591,0,0,1-.6-.6V5.8A.591.591,0,0,1,9.8,5.2Zm5.8.848L18.752,9.2H16.2a.591.591,0,0,1-.6-.6ZM10.9,9.6a.5.5,0,0,0-.5.5v3.8a.5.5,0,0,0,1,0v-.7h.8a1.769,1.769,0,0,0,.207-.021l1.6,2.4-1.123,1.642a.5.5,0,1,0,.825.565l.9-1.312.877,1.312a.5.5,0,1,0,.825-.565l-1.095-1.636,1.095-1.6a.5.5,0,1,0-.825-.565l-.868,1.269-1.277-1.908A1.792,1.792,0,0,0,12.2,9.6Zm.5,1h.8a.8.8,0,0,1,0,1.6h-.8Z"
        transform="translate(-8 -4)"
        fill="#0e1824"
      />
    </SvgIcon>
  );
}

export function ExpertDoneIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 100,
    height: 100,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 100 100"
      {...rest}
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 44620"
            fill="#6552cc"
            d="M0 0H100V100H0z"
          />
        </clipPath>
      </defs>
      <g data-name="icons8-ok 1" clipPath="url(#a)">
        <path
          data-name="Path 4860"
          d="M60.67 1.89a49.279 49.279 0 1037.438 58.781A49.288 49.288 0 0060.67 1.89zm17.918 38.831l-34.24 32.325a4.139 4.139 0 01-3.6 1.186 5.3 5.3 0 01-3.048-2.244l-11.772-18.51a2.72 2.72 0 01.83-3.74l4.57-2.911a2.7 2.7 0 013.726.826l7.674 12.028 28.421-26.843a2.738 2.738 0 013.838.112l3.725 3.95a2.714 2.714 0 01-.124 3.821z"
          fill="#6552cc"
        />
      </g>
    </SvgIcon>
  );
}

export function ExpertAddFileIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 87,
    height: 62,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 87.966 62.332"
      {...rest}
    >
      <g data-name="Add files-rafiki">
        <g transform="translate(-63.825 -175.771) translate(63.825 175.771)">
          <path
            data-name="Rectangle 56141"
            transform="rotate(-6.67 264.541 15.416)"
            fill="#cfd8dc"
            d="M0 0H0.326V4.956H0z"
          />
          <path
            data-name="Rectangle 56142"
            transform="rotate(-6.67 322.888 12.014)"
            fill="#cfd8dc"
            d="M0 0H0.326V2.5H0z"
          />
          <path
            data-name="Path 5976"
            d="M86.907 233.489l-.384-1.077a3.472 3.472 0 00-3.677-2.283l-15.28 1.787a3.475 3.475 0 00-3.047 3.856l4.348 37.185a2.382 2.382 0 002.644 2.091l54.674-6.395a2.382 2.382 0 002.1-2.644l-3.773-32.146a2.382 2.382 0 00-2.641-2.091l-31.751 3.716a3.041 3.041 0 01-3.213-1.999z"
            transform="translate(-64.281 -212.732)"
            fill="#cfd8dc"
          />
          <path
            data-name="Rectangle 56143"
            transform="rotate(-11.27 44.126 -30.835)"
            fill="#cfd8dc"
            d="M0 0H17.614V24.268H0z"
          />
          <path
            data-name="Rectangle 56144"
            transform="rotate(-11.27 44.126 -30.835)"
            fill="#fff"
            opacity={0.7}
            d="M0 0H17.614V24.268H0z"
          />
          <g data-name="Group 106012" opacity={0.4} fill="#cfd8dc">
            <path
              data-name="Path 5977"
              d="M107.085 204l-10.641 2.123a.959.959 0 01-1.122-.748.959.959 0 01.748-1.122l10.647-2.113a.959.959 0 011.122.748.959.959 0 01-.754 1.112z"
              transform="translate(10.065 8.426) translate(-95.304 -202.124)"
            />
            <path
              data-name="Path 5978"
              d="M109.543 216.348L98.9 218.481a.959.959 0 01-1.119-.748.959.959 0 01.748-1.119l10.641-2.12a.959.959 0 011.119.748.959.959 0 01-.746 1.106z"
              transform="translate(10.065 8.426) translate(-96.979 -210.527)"
            />
            <path
              data-name="Path 5979"
              d="M111.993 228.624l-10.641 2.12a.959.959 0 01-1.119-.748.959.959 0 01.748-1.119l10.641-2.123a.959.959 0 011.119.748.959.959 0 01-.748 1.122z"
              transform="translate(10.065 8.426) translate(-98.646 -218.867)"
            />
            <path
              data-name="Path 5980"
              d="M114.445 240.983L103.8 243.1a.959.959 0 01-1.122-.748.959.959 0 01.748-1.122l10.641-2.12a.959.959 0 011.122.748.959.959 0 01-.748 1.122z"
              transform="translate(10.065 8.426) translate(-100.311 -227.274)"
            />
            <path
              data-name="Path 5981"
              d="M113.992 255.054l-7.731 1.541a.959.959 0 01-1.119-.748.959.959 0 01.748-1.122l7.731-1.541a.959.959 0 011.119.748.959.959 0 01-.748 1.122z"
              transform="translate(10.065 8.426) translate(-101.985 -236.847)"
            />
          </g>
          <path
            data-name="Rectangle 56145"
            transform="rotate(-7.81 33.122 -227.988)"
            fill="#cfd8dc"
            d="M0 0H17.614V24.268H0z"
          />
          <path
            data-name="Rectangle 56146"
            transform="rotate(-7.81 33.122 -227.988)"
            fill="#fff"
            opacity={0.7}
            d="M0 0H17.614V24.268H0z"
          />
          <g data-name="Group 106013" opacity={0.4} fill="#cfd8dc">
            <path
              data-name="Path 5982"
              d="M182.886 189.162l-10.749 1.471a.959.959 0 01-1.074-.815.959.959 0 01.815-1.074l10.749-1.471a.959.959 0 011.074.815.959.959 0 01-.815 1.074z"
              transform="translate(34.285 3.675) translate(-171.054 -187.264)"
            />
            <path
              data-name="Path 5983"
              d="M184.587 201.6l-10.749 1.471a.959.959 0 01-1.074-.815.959.959 0 01.815-1.071l10.749-1.471a.959.959 0 011.074.812.959.959 0 01-.815 1.074z"
              transform="translate(34.285 3.675) translate(-172.212 -195.727)"
            />
            <path
              data-name="Path 5984"
              d="M178.5 217.363l-2.961.406a.959.959 0 01-1.074-.815.959.959 0 01.815-1.074l2.964-.406a.959.959 0 011.071.815.959.959 0 01-.815 1.074z"
              transform="translate(34.285 3.675) translate(-173.367 -206.449)"
            />
            <path
              data-name="Path 5985"
              d="M196.467 214.909l-2.964.406a.959.959 0 01-1.071-.815.959.959 0 01.815-1.074l2.961-.4a.959.959 0 011.074.812.959.959 0 01-.815 1.071z"
              transform="translate(34.285 3.675) translate(-185.592 -204.781)"
            />
            <path
              data-name="Path 5986"
              d="M187.987 226.462l-10.749 1.471a.959.959 0 01-1.074-.815.959.959 0 01.815-1.071l10.749-1.474a.959.959 0 011.074.815.959.959 0 01-.815 1.074z"
              transform="translate(34.285 3.675) translate(-174.524 -212.638)"
            />
            <path
              data-name="Path 5987"
              d="M186.758 240.16l-7.814 1.068a.959.959 0 01-1.071-.812.959.959 0 01.812-1.074l7.814-1.068a.959.959 0 011.071.812.959.959 0 01-.812 1.074z"
              transform="translate(34.285 3.675) translate(-175.687 -221.959)"
            />
          </g>
          <path
            data-name="Rectangle 56147"
            transform="rotate(-4.98 65.29 -167.088)"
            fill="#cfd8dc"
            d="M0 0H17.614V24.268H0z"
          />
          <path
            data-name="Rectangle 56148"
            transform="rotate(-4.98 65.29 -167.088)"
            fill="#fff"
            opacity={0.8}
            d="M0 0H17.614V24.268H0z"
          />
          <g data-name="Group 106014" opacity={0.4} fill="#cfd8dc">
            <path
              data-name="Path 5988"
              d="M130.507 199.678l-10.81.94a.959.959 0 01-1.033-.866.959.959 0 01.866-1.03l10.81-.959a.959.959 0 011.033.866.959.959 0 01-.866 1.049z"
              transform="translate(17.533 7.031) translate(-118.661 -197.76)"
            />
            <path
              data-name="Path 5989"
              d="M131.6 212.212l-10.81.959a.959.959 0 01-1.033-.866.959.959 0 01.866-1.033l10.81-.959a.959.959 0 011.033.866.959.959 0 01-.866 1.033z"
              transform="translate(17.533 7.031) translate(-119.402 -206.297)"
            />
            <path
              data-name="Path 5990"
              d="M132.686 224.712l-10.81.959a.959.959 0 01-1.033-.866.959.959 0 01.866-1.033l10.81-.959a.959.959 0 011.033.866.959.959 0 01-.866 1.033z"
              transform="translate(17.533 7.031) translate(-120.143 -214.801)"
            />
            <path
              data-name="Path 5991"
              d="M133.8 237.253l-10.81.959a.959.959 0 01-1.033-.866.959.959 0 01.866-1.033l10.81-.94a.959.959 0 011.033.867.959.959 0 01-.866 1.013z"
              transform="translate(17.533 7.031) translate(-120.898 -223.345)"
            />
            <path
              data-name="Path 5992"
              d="M131.891 250.522l-7.856.684a.959.959 0 01-1.042-.866.959.959 0 01.866-1.033l7.856-.684a.959.959 0 011.033.866.959.959 0 01-.857 1.033z"
              transform="translate(17.533 7.031) translate(-121.606 -232.358)"
            />
          </g>
          <path
            data-name="Rectangle 56149"
            transform="rotate(-2.76 84.086 -747.386)"
            fill="#cfd8dc"
            d="M0 0H17.614V24.268H0z"
          />
          <path
            data-name="Rectangle 56150"
            transform="rotate(-2.76 84.086 -747.386)"
            fill="#fff"
            opacity={0.8}
            d="M0 0H17.614V24.268H0z"
          />
          <g data-name="Group 106015" opacity={0.4} fill="#cfd8dc">
            <path
              data-name="Path 5993"
              d="M196.762 195.651l-10.836.524a.959.959 0 01-1-.9.959.959 0 01.9-1l10.839-.524a.959.959 0 011 .9.959.959 0 01-.903 1z"
              transform="translate(38.72 5.748) translate(-184.927 -193.747)"
            />
            <path
              data-name="Path 5994"
              d="M197.365 208.184l-10.839.521a.959.959 0 01-1-.9.959.959 0 01.908-1l10.836-.524a.959.959 0 011 .908.959.959 0 01-.905.995z"
              transform="translate(38.72 5.748) translate(-185.336 -202.271)"
            />
            <path
              data-name="Path 5995"
              d="M190.122 221.944l-2.986.144a.959.959 0 01-1-.9.959.959 0 01.9-1l2.986-.147a.959.959 0 011 .908.959.959 0 01-.9 1z"
              transform="translate(38.72 5.748) translate(-185.751 -211.632)"
            />
            <path
              data-name="Path 5996"
              d="M208.232 221.031l-2.986.144a.959.959 0 01-1-.9.959.959 0 01.9-1l2.986-.144a.959.959 0 011 .9.959.959 0 01-.9 1z"
              transform="translate(38.72 5.748) translate(-198.07 -211.013)"
            />
            <path
              data-name="Path 5997"
              d="M198.575 233.254l-10.839.521a.959.959 0 01-1-.9.959.959 0 01.908-1l10.836-.524a.959.959 0 011 .908.959.959 0 01-.905.995z"
              transform="translate(38.72 5.748) translate(-186.159 -219.325)"
            />
            <path
              data-name="Path 5998"
              d="M196.221 246.241l-7.875.38a.959.959 0 01-1-.9.959.959 0 01.9-1l7.875-.38a.959.959 0 011 .9.959.959 0 01-.9 1z"
              transform="translate(38.72 5.748) translate(-186.574 -228.162)"
            />
          </g>
          <path
            data-name="Path 5999"
            d="M102.286 235.767l-.286-1.052a3.076 3.076 0 00-3.424-2.238L83.3 234.265a3.837 3.837 0 00-3.37 3.792l.866 36.4a2.1 2.1 0 002.42 2.04l54.674-6.395a2.628 2.628 0 002.312-2.593l-.748-31.468a2.1 2.1 0 00-2.424-2.04l-31.746 3.712a2.689 2.689 0 01-2.998-1.946z"
            transform="translate(-74.781 -214.323)"
            fill="#bdc8cd"
          />
        </g>
        <g transform="translate(-63.825 -175.771) translate(129.592 179.124)">
          <path
            data-name="Path 6003"
            d="M290.9 208.334l-1.794-1.794-.959 2.807a3.4 3.4 0 002.964.045z"
            transform="translate(-282.193 -200.056)"
            fill="#ffc3bd"
          />
          <path
            data-name="Path 6037"
            d="M327.237 226.874l.32-.026c.061 0 .105-.042.1-.08l-.262-1.324a.115.115 0 00-.128-.061l-.32.026c-.064 0-.109.042-.1.08l.262 1.324c.01.045.068.067.128.061z"
            transform="translate(-308.517 -212.873)"
            fill="#cfd8dc"
          />
          <path
            data-name="Path 6047"
            d="M298.6 210.477l1.848-20.082-3.949-3.025-12.054-1.109-2.094 22.72z"
            transform="translate(-278.248 -186.26)"
            fill="#cfd8dc"
          />
          <path
            data-name="Path 6048"
            d="M298.6 210.477l1.848-20.082-3.949-3.025-12.054-1.109-2.094 22.72z"
            transform="translate(-278.248 -186.26)"
            fill="#fff"
            opacity={0.8}
          />
          <path
            data-name="Path 6049"
            d="M330.549 192.755l-3.949-3.025 1.036 3.619z"
            transform="translate(-308.349 -188.621)"
            fill="#cfd8dc"
          />
          <circle
            data-name="Ellipse 129817"
            cx={4.924}
            cy={4.924}
            r={4.924}
            transform="translate(.592 16.383)"
            fill="#ee8438"
          />
          <circle
            data-name="Ellipse 129818"
            cx={3.926}
            cy={3.926}
            r={3.926}
            transform="matrix(.785 -.62 .62 .785 0 20.656)"
            fill="#fff"
          />
          <path
            data-name="Path 6050"
            d="M284.034 247.391l-1.733-.2.2-1.733-1.241-.147-.2 1.733-1.733-.2-.147 1.244 1.733.2-.2 1.73 1.244.147.2-1.733 1.733.2z"
            transform="translate(-276.091 -226.43)"
            fill="#ee8438"
          />
          <path
            data-name="Path 6051"
            d="M305.317 207.368a1.343 1.343 0 01-1.461 1.215l-8.793-.809a1.346 1.346 0 01-1.215-1.461 1.343 1.343 0 011.461-1.215l8.793.809a1.343 1.343 0 011.215 1.461z"
            transform="translate(-286.066 -199.071)"
            fill="#cfd8dc"
            opacity={0.4}
          />
          <path
            data-name="Path 6052"
            d="M301.579 219.235a1.343 1.343 0 01-1.461 1.215l-6.145-.566a1.343 1.343 0 01-1.215-1.461 1.343 1.343 0 011.461-1.215l6.145.569a1.346 1.346 0 011.215 1.458z"
            transform="translate(-285.324 -207.309)"
            fill="#cfd8dc"
            opacity={0.4}
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function LeftArrowClickIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 16.009,
    height: 13.788,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.009 13.788"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-down-50"
        d="M6.878,16.009a.667.667,0,0,1-.656-.676V2.276L1.138,7.36A.667.667,0,1,1,.2,6.417L6.417.2A.667.667,0,0,1,7.36.2l6.222,6.222a.667.667,0,1,1-.943.943L7.555,2.276V15.333a.667.667,0,0,1-.677.676Z"
        transform="translate(16.009) rotate(90)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function BrainIcon(props) {
  const { rootStyle, color, ...rest } = props;
  const rootSx = {
    width: 25,
    height: 25,
    color: '#000',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      sx={rootSx}
      {...rest}
    >
      <g
        id="Group_106163"
        data-name="Group 106163"
        transform="translate(-29 -278)"
      >
        <path
          id="icons8-brain"
          d="M11.2,2.926a3.611,3.611,0,0,0-.566.027,2.481,2.481,0,0,0-1.161.452A3.434,3.434,0,0,0,8.387,6,7.653,7.653,0,0,0,5.628,7.6,4.592,4.592,0,0,0,4.1,10.216a5.384,5.384,0,0,0,.911,3.655,5.466,5.466,0,0,0-.275,1.686,4.828,4.828,0,0,0,2.1,4.158,4.994,4.994,0,0,0,1.578.707,2.765,2.765,0,0,0,1.018,2,3.852,3.852,0,0,0,2.189.508,2.786,2.786,0,0,0,1.8-.58c.04-.032.076-.069.113-.1.037.035.074.072.113.1a2.786,2.786,0,0,0,1.8.58,3.856,3.856,0,0,0,2.19-.508,2.764,2.764,0,0,0,1.017-2,4.994,4.994,0,0,0,1.578-.707,4.828,4.828,0,0,0,2.1-4.158,5.467,5.467,0,0,0-.274-1.687,5.385,5.385,0,0,0,.911-3.654A4.592,4.592,0,0,0,21.458,7.6,7.65,7.65,0,0,0,18.7,6a3.434,3.434,0,0,0-1.086-2.6,2.481,2.481,0,0,0-1.161-.452,4.4,4.4,0,0,0-1.08.012,3.111,3.111,0,0,0-1.7.751c-.047.042-.087.094-.132.139-.045-.046-.085-.1-.132-.139a3.111,3.111,0,0,0-1.7-.751C11.554,2.947,11.382,2.931,11.2,2.926Zm-.02,1.43c.118,0,.242.011.37.026a1.773,1.773,0,0,1,.917.4.9.9,0,0,1,.353.679V20.57a.758.758,0,0,1-.291.668,1.4,1.4,0,0,1-.891.26,2.854,2.854,0,0,1-1.414-.269c-.277-.184-.494-.466-.494-1.394a.713.713,0,0,0-.618-.706,3.959,3.959,0,0,1-1.482-.6,3.224,3.224,0,0,1-1.465-2.972c0-1.678.739-2.543,1.506-2.841a1.686,1.686,0,0,1,2.16.831.713.713,0,0,0,1.224-.733,3.2,3.2,0,0,0-3.9-1.427,3.415,3.415,0,0,0-1.282.965,3.624,3.624,0,0,1-.364-1.9,3.155,3.155,0,0,1,1.075-1.8A7.843,7.843,0,0,1,9.213,7.211a.713.713,0,0,0,.517-.685c0-1.3.308-1.768.584-1.97a1.119,1.119,0,0,1,.529-.185A2.4,2.4,0,0,1,11.179,4.356Zm4.726,0a2.4,2.4,0,0,1,.336.015,1.115,1.115,0,0,1,.528.185c.276.2.584.666.584,1.97a.713.713,0,0,0,.517.685A7.843,7.843,0,0,1,20.5,8.658a3.155,3.155,0,0,1,1.075,1.8,3.622,3.622,0,0,1-.363,1.9,3.414,3.414,0,0,0-1.282-.965,3.2,3.2,0,0,0-3.9,1.427.713.713,0,1,0,1.223.734,1.686,1.686,0,0,1,2.16-.831c.767.3,1.506,1.162,1.506,2.841a3.224,3.224,0,0,1-1.465,2.972,3.957,3.957,0,0,1-1.481.6.713.713,0,0,0-.619.706c0,.929-.217,1.21-.494,1.394a2.85,2.85,0,0,1-1.413.269,1.4,1.4,0,0,1-.891-.26.759.759,0,0,1-.291-.668V5.464a.9.9,0,0,1,.353-.679,1.776,1.776,0,0,1,.918-.4C15.664,4.367,15.788,4.358,15.906,4.356ZM11.182,7.229a.713.713,0,0,0-.718.895,1.178,1.178,0,0,1-.035.527c-.087.231-.176.488-1.174.488a.713.713,0,1,0,0,1.426,2.531,2.531,0,0,0,2.509-1.413,2.41,2.41,0,0,0,.084-1.374A.713.713,0,0,0,11.182,7.229Zm4.77,0a.713.713,0,0,0-.716.55,2.41,2.41,0,0,0,.084,1.374,2.531,2.531,0,0,0,2.509,1.413.713.713,0,1,0,0-1.426c-1,0-1.087-.257-1.174-.488a1.178,1.178,0,0,1-.035-.527.713.713,0,0,0-.668-.895Zm-6.66,8.06a1.934,1.934,0,0,0-.447.051.713.713,0,1,0,.345,1.383.807.807,0,0,1,.46.065c.22.11.556.352.556,1.62a.713.713,0,1,0,1.426,0,3.023,3.023,0,0,0-1.345-2.9A2.18,2.18,0,0,0,9.292,15.289Zm8.5,0a2.184,2.184,0,0,0-1,.224,3.023,3.023,0,0,0-1.345,2.9.713.713,0,1,0,1.426,0c0-1.268.337-1.51.557-1.62a.8.8,0,0,1,.459-.065.713.713,0,1,0,.346-1.383A1.942,1.942,0,0,0,17.793,15.289Z"
          transform="translate(27.45 277.075)"
          fill={color}
        />
        <rect
          id="Rectangle_56176"
          data-name="Rectangle 56176"
          width="24"
          height="24"
          transform="translate(29 278)"
          fill="none"
        />
      </g>
    </SvgIcon>
  );
}

export function RuningIcon(props) {
  const { rootStyle, color, ...rest } = props;
  const rootSx = {
    width: 16,
    height: 17.884,
    color: '#000',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 17.884"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-running"
        d="M19.7,6a1.882,1.882,0,1,0,1.883,1.881A1.882,1.882,0,0,0,19.7,6ZM11.9,9.293a1.647,1.647,0,0,0-1.264.593L8.57,12.37a.706.706,0,1,0,1.084.9L11.7,10.819l2.641.323-2.261,3.145a1.861,1.861,0,0,0,.542,2.731v0l.037.017a1.854,1.854,0,0,0,.266.128L16.751,19l.608,4.347.006,0a.706.706,0,0,0,1.391-.175V18a.706.706,0,0,0-.335-.6l-1.19-.734-1.565-.988,1.874-2.7.9,1.228h0a.706.706,0,0,0,.549.264h3.293a.706.706,0,1,0,0-1.411H19.432l-1.281-2.608q-.013-.026-.028-.051c-.016-.027-.034-.051-.051-.076A1.876,1.876,0,0,0,16.4,9.293c-.06,0-.116.012-.175.017-.208-.018-.4-.017-.564-.017Zm-.089,8.381-.492,1.487-3.68.484a.706.706,0,0,0,.057,1.41h4.234a.711.711,0,0,0,.662-.437l0,0,1.232-1.972C13.28,18.417,12.36,17.952,11.815,17.674Z"
        transform="translate(-6.991 -6)"
        fill={color}
      />
    </SvgIcon>
  );
}

export function TickBadgeIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 14,
    height: 14,

    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      sx={rootSx}
      {...rest}
    >
      <g
        id="Group_106412"
        data-name="Group 106412"
        transform="translate(-67 -145)"
      >
        <g
          id="Ellipse_39431"
          data-name="Ellipse 39431"
          transform="translate(68 146)"
          fill="#25c460"
          stroke="#fff"
        >
          <circle cx="6" cy="6" r="6" stroke="none" />
          <circle cx="6" cy="6" r="6.5" fill="none" />
        </g>
        <path
          id="icons8-checkmark"
          d="M9.656,8.98a.333.333,0,0,0-.229.1L5.332,13.175,3.568,11.412a.333.333,0,1,0-.471.471l2,2a.333.333,0,0,0,.471,0L9.9,9.552a.333.333,0,0,0-.242-.572Z"
          transform="translate(67.501 140.52)"
          fill="#fff"
          stroke="#fff"
        />
      </g>
    </SvgIcon>
  );
}

export function InprogressBadgeIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 25,
    height: 25,

    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      sx={rootSx}
      {...rest}
    >
      <g
        id="Group_106166"
        data-name="Group 106166"
        transform="translate(-272 -282)"
      >
        <g
          id="Group_106435"
          data-name="Group 106435"
          transform="translate(107 5)"
        >
          <g
            id="Ellipse_129856"
            data-name="Ellipse 129856"
            transform="translate(177 289)"
            fill="#ff980e"
            stroke="rgba(255,255,255,0.8)"
          >
            <circle cx="6" cy="6" r="6" stroke="none" />
            <circle cx="6" cy="6" r="6.5" fill="none" />
          </g>
          <path
            id="icons8-session-timeout"
            d="M6.043,2A4,4,0,0,0,2.057,5.566a.4.4,0,0,0,.8.088A3.209,3.209,0,1,1,6.043,9.22a.4.4,0,0,0,0,.8A4.011,4.011,0,0,0,6.043,2ZM6.037,3.6a.4.4,0,0,0-.395.407V6.011a.4.4,0,0,0,.4.4h1.2a.4.4,0,1,0,.011-.8H6.445v-1.6a.4.4,0,0,0-.4-.407ZM2.785,6.692a.2.2,0,0,0-.079,0l-.39.095a.2.2,0,0,0-.148.244,4.05,4.05,0,0,0,.134.416.2.2,0,0,0,.269.107L2.938,7.4a.2.2,0,0,0,.1-.257c-.035-.095-.066-.193-.094-.3A.205.205,0,0,0,2.785,6.692Zm.63,1.254a.193.193,0,0,0-.144.034l-.327.233A.2.2,0,0,0,2.9,8.5a4,4,0,0,0,.311.349.2.2,0,0,0,.29-.012l.268-.3a.2.2,0,0,0-.01-.277,3,3,0,0,1-.213-.239A.211.211,0,0,0,3.415,7.947Zm1.09.9a.2.2,0,0,0-.193.095l-.2.345a.2.2,0,0,0,.075.28,4.068,4.068,0,0,0,.426.193.2.2,0,0,0,.26-.128l.125-.381A.2.2,0,0,0,4.872,9c-.1-.039-.2-.083-.292-.132A.212.212,0,0,0,4.5,8.843Z"
            transform="translate(176.946 288.989)"
            fill="#fff"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function FoodIcon(props) {
  const { rootStyle, color, ...rest } = props;
  const rootSx = {
    width: 25,
    height: 25,
    color: '#000',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      sx={rootSx}
      {...rest}
    >
      <g
        id="Group_106166"
        data-name="Group 106166"
        transform="translate(-272 -282)"
      >
        <rect
          id="Rectangle_56178"
          data-name="Rectangle 56178"
          width="24"
          height="24"
          transform="translate(272 282)"
          fill="none"
        />
        <path
          id="icons8-rice-bowl"
          d="M13.358,1.605,11,7.1A3.279,3.279,0,0,0,8.518,6.026l-.131,0H8.376A3.818,3.818,0,0,0,5.687,7.208a3.212,3.212,0,0,0-1.409-.362,3.346,3.346,0,0,0-2.185.813A3.238,3.238,0,0,0,1,10.124v.043h.475L1,10.185a9.051,9.051,0,0,0,1.878,5A5.971,5.971,0,0,0,7.556,17.5h4.917a5.937,5.937,0,0,0,4.647-2.337,9.142,9.142,0,0,0,1.8-4.509l0,0,.054-.126s.022-.082.026-.1c.008-.04.01-.054.011-.067a.571.571,0,0,0,0-.072c0-.066.006-.139.006-.139h-.011a3.264,3.264,0,0,0-1.141-2.489,3.413,3.413,0,0,0-1.385-.709l1.554-2.071L16.734,3.9,14.276,7.174,14.3,7.2c-.158.079-.306.161-.435.242a4.412,4.412,0,0,0-.663-.407c-.131-.044-.237-.066-.349-.093l2.009-4.687ZM8.374,7.661l.133,0h.011a2.454,2.454,0,0,1,1.655.895l.461.629.651-.431a2.062,2.062,0,0,1,.933-.269h.016a3.176,3.176,0,0,1,.451.1,1.559,1.559,0,0,1,.61.359l.49.515.579-.411a2.747,2.747,0,0,1,1.386-.563,1.866,1.866,0,0,1,1.066.424,1.52,1.52,0,0,1,.554,1.215H2.65c0-.006,0-.012,0-.018A1.492,1.492,0,0,1,3.164,8.9a1.8,1.8,0,0,1,1.114-.416,2.094,2.094,0,0,1,1.205.287l.552.344L6.5,8.655A2.82,2.82,0,0,1,8.374,7.661Zm10.55,2.22.062.147L19,10.1s0,.026.006.048l-.52-.03Zm-1.444,0,.362.192-.427-.024.011-.042ZM2.969,11.763H17.032a7.088,7.088,0,0,1-1.191,2.374,4.2,4.2,0,0,1-3.368,1.724H7.556a4.23,4.23,0,0,1-3.4-1.708A6.886,6.886,0,0,1,2.969,11.763Z"
          transform="translate(273.985 284.447)"
          fill={color}
        />
      </g>
    </SvgIcon>
  );
}

export function DumbleSmallIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 12.776,
    height: 11.964,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 12.776 11.964"
      {...rest}
    >
      <g data-name="Group 106397" transform="rotate(-41 10.528 5.643)">
        <path
          data-name="Rectangle 56191"
          transform="rotate(-.1 1552.675 -2578.675)"
          fill="#3d3f3e"
          d="M0 0H5.359V1.522H0z"
        />
        <g data-name="Group 106395">
          <path
            data-name="Path 100456"
            d="M0 0h.1a.731.731 0 01.726.731v.325a.731.731 0 01-.726.73H0V0z"
            transform="translate(0 .013) rotate(179.9 .413 2.037)"
            fill="#8b7fca"
          />
          <path
            data-name="Path 100457"
            d="M867.268 466.44l.008 4.532a1.641 1.641 0 01-1.643-1.638v-1.251a1.641 1.641 0 011.638-1.643z"
            transform="translate(0 .013) translate(-864.951 -465.528)"
            fill="#8b7fca"
          />
          <path
            data-name="Path 100458"
            d="M898.138 447.63a1.15 1.15 0 011.151 1.148l.007 4.052a1.15 1.15 0 01-1.148 1.152 1.15 1.15 0 01-1.148-1.148l-.007-4.052a1.15 1.15 0 011.145-1.152z"
            transform="translate(0 .013) translate(-894.791 -447.629)"
            fill="#8b7fca"
          />
          <path
            data-name="Path 100459"
            d="M851.781 498.145a.891.891 0 00.219.594.73.73 0 01-.341-.617v-.322a.728.728 0 01.338-.618.892.892 0 00-.218.595v.37z"
            transform="translate(0 .013) translate(-851.657 -494.778)"
            fill="#7d6fc4"
          />
          <path
            data-name="Path 100460"
            d="M897.661 453.636a1.149 1.149 0 00.646.323 1.2 1.2 0 01-.168.013 1.15 1.15 0 01-1.151-1.148l-.007-4.052a1.15 1.15 0 011.147-1.152 1.194 1.194 0 01.168.012 1.15 1.15 0 00-.979 1.139l.007 4.052a1.146 1.146 0 00.338.812z"
            transform="translate(0 .013) translate(-894.781 -447.62)"
            fill="#7d6fc4"
          />
          <path
            data-name="Path 100461"
            d="M865.828 468.073v1.251a1.64 1.64 0 001.455 1.627v.011a1.64 1.64 0 01-1.643-1.638v-1.251a1.641 1.641 0 011.638-1.643v.011a1.641 1.641 0 00-1.45 1.632z"
            transform="translate(0 .013) translate(-864.96 -465.518)"
            fill="#7d6fc4"
          />
        </g>
        <g data-name="Group 106396">
          <path
            data-name="Path 100462"
            d="M0 0h.1a.731.731 0 01.726.731v.325a.731.731 0 01-.726.73H0V0z"
            transform="translate(9.857) rotate(-.1 1308.18 -2104.48)"
            fill="#8b7fca"
          />
          <path
            data-name="Path 100463"
            d="M1099.96 466.09l.008 4.532a1.64 1.64 0 001.637-1.643v-1.251a1.641 1.641 0 00-1.643-1.638z"
            transform="translate(9.857) translate(-1097.781 -465.182)"
            fill="#8b7fca"
          />
          <path
            data-name="Path 100464"
            d="M1056.138 447.36a1.15 1.15 0 00-1.148 1.152l.007 4.052a1.15 1.15 0 001.152 1.148 1.15 1.15 0 001.148-1.152l-.007-4.052a1.15 1.15 0 00-1.152-1.148z"
            transform="translate(9.857) translate(-1054.99 -447.359)"
            fill="#8b7fca"
          />
          <path
            data-name="Path 100465"
            d="M1141.1 497.644a.894.894 0 01-.218.595.73.73 0 00.339-.618v-.321a.732.732 0 00-.341-.617.892.892 0 01.22.594v.37z"
            transform="translate(9.857) translate(-1136.717 -494.289)"
            fill="#7d6fc4"
          />
          <path
            data-name="Path 100466"
            d="M1075.856 453.363a1.146 1.146 0 01-.645.326 1.128 1.128 0 00.168.012 1.15 1.15 0 001.148-1.152l-.007-4.052a1.149 1.149 0 00-1.152-1.147 1.127 1.127 0 00-.168.013 1.15 1.15 0 01.983 1.135l.007 4.052a1.144 1.144 0 01-.335.813z"
            transform="translate(9.857) translate(-1074.22 -447.35)"
            fill="#7d6fc4"
          />
          <path
            data-name="Path 100467"
            d="M1101.426 467.728v1.251a1.64 1.64 0 01-1.45 1.632v.011a1.64 1.64 0 001.638-1.643v-1.251a1.641 1.641 0 00-1.644-1.638v.011a1.641 1.641 0 011.456 1.627z"
            transform="translate(9.857) translate(-1097.79 -465.182)"
            fill="#7d6fc4"
          />
        </g>
        <path
          data-name="Rectangle 56192"
          transform="rotate(-.1 2205.275 -2579.825)"
          fill="#272827"
          d="M0 0H5.359V0.382H0z"
        />
      </g>
    </SvgIcon>
  );
}

export function AwardsEmptyState(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 128,
    height: 118,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 128.252 118.438"
      {...rest}
    >
      <path
        data-name="Path 20625"
        d="M199.688 152.67c.327-1.875.852-3.73 1.228-5.64a33.34 33.34 0 00.157-11.169 43.873 43.873 0 00-8.233-19.6c-4.586-6.152-11.482-11.134-18.894-9.252-7.711 1.949-14.238 7.9-21.737 10.609-12.7 4.593-25.557-3.779-38.355-3.48-11.051.24-22.645 4.207-29.924 14.016-2.972 4-5.042 9.395-4.339 14.7.859 6.462 5.6 11.378 9.137 16.159 5.421 7.328 7.474 15.31 2.912 23.863-3.083 5.8-7.23 10.919-6.872 18.118.574 11.517 11.208 18.473 19.976 21.573 8.908 3.152 19.023 3.48 27.878-.07 7.867-3.166 13.358-10.091 20.529-14.51a32.45 32.45 0 0121.055-4.621c7.578.9 15.564 2.5 22.888-.769 7.008-3.132 10.327-11.5 10.588-19.52a32.063 32.063 0 00-1.778-11.775c-1.625-4.544-5.219-8.09-6.232-12.909a14.962 14.962 0 01.014-5.717z"
        transform="translate(-77.798 -112.187) translate(77.798 112.187) translate(-79.454 -106.601)"
        fill="#c9c4e9"
      />
      <path
        data-name="Path 20626"
        d="M199.688 152.67c.327-1.875.852-3.73 1.228-5.64a33.34 33.34 0 00.157-11.169 43.873 43.873 0 00-8.233-19.6c-4.586-6.152-11.482-11.134-18.894-9.252-7.711 1.949-14.238 7.9-21.737 10.609-12.7 4.593-25.557-3.779-38.355-3.48-11.051.24-22.645 4.207-29.924 14.016-2.972 4-5.042 9.395-4.339 14.7.859 6.462 5.6 11.378 9.137 16.159 5.421 7.328 7.474 15.31 2.912 23.863-3.083 5.8-7.23 10.919-6.872 18.118.574 11.517 11.208 18.473 19.976 21.573 8.908 3.152 19.023 3.48 27.878-.07 7.867-3.166 13.358-10.091 20.529-14.51a32.45 32.45 0 0121.055-4.621c7.578.9 15.564 2.5 22.888-.769 7.008-3.132 10.327-11.5 10.588-19.52a32.063 32.063 0 00-1.778-11.775c-1.625-4.544-5.219-8.09-6.232-12.909a14.962 14.962 0 01.014-5.717z"
        transform="translate(-77.798 -112.187) translate(77.798 112.187) translate(-79.454 -106.601)"
        fill="#fff"
        opacity={0.7}
      />
      <g data-name="Group 123414">
        <path
          data-name="Path 109747"
          d="M325.838 1655.75l-1.578-.9-.785-.45-7.475-4.291-4.8 7.157-.505.755-1.012 1.51a.762.762 0 01-1.376-.252l-1.888-8.073-.343-1.459-1.915-8.184-.276-1.179-2.623-11.2 2.346-.549 2.617.587 2.464-.553 11.518-2.583 2.08 8.892.356 1.518 4.311 18.423a.761.761 0 01-1.116.831z"
          transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(-101.696 -184.333)"
          fill="#5b48bd"
        />
        <g data-name="Group 123340">
          <g data-name="Group 123339">
            <g data-name="Group 123337">
              <path
                data-name="Path 109748"
                d="M387.694 1622.48l6.748 28.833.786.451-6.889-29.434z"
                transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(202.112 1441.079) translate(12.918) translate(-387.694 -1622.33)"
                fill="#d5ccff"
              />
            </g>
            <g data-name="Group 123338">
              <path
                data-name="Path 109749"
                d="M315.484 1639.372l6.889 29.435.506-.755-6.747-28.833z"
                transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(202.112 1441.079) translate(0 3.022) translate(-315.484 -1639.22)"
                fill="#d5ccff"
              />
            </g>
          </g>
        </g>
        <path
          data-name="Path 109750"
          d="M311.577 1637.866l-2.619 11.19-2.2 9.376-.341 1.46-.343-1.46-2.191-9.361-2.623-11.2 4.814-1.127.343-.079.341.079z"
          transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(-101.697 -193.017)"
          fill="#7a67d9"
          opacity={0.78}
        />
        <path
          data-name="Path 109751"
          d="M237.05 1628.887l-2.619 11.191-.282 1.2-1.913 8.175-2.236 9.533a.762.762 0 01-1.376.252l-1.012-1.51-.505-.755-4.8-7.157-7.475 4.286-.785.451-1.578.9a.762.762 0 01-1.122-.835l4.333-18.512.312-1.334 2.117-9.051 11.651 2.613 2.617.587 2.464-.552z"
          transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(-27.853 -184.039)"
          fill="#5b48bd"
        />
        <g data-name="Group 123344">
          <g data-name="Group 123343">
            <g data-name="Group 123341">
              <path
                data-name="Path 109752"
                d="M234.074 1622.48l-6.748 28.833-.786.451 6.889-29.434z"
                transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(186.201 1441.079) translate(-226.54 -1622.33)"
                fill="#d5ccff"
              />
            </g>
            <g data-name="Group 123342">
              <path
                data-name="Path 109753"
                d="M306.923 1639.372l-6.889 29.435-.506-.755 6.747-28.833z"
                transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(186.201 1441.079) translate(13.057 3.022) translate(-299.528 -1639.22)"
                fill="#d5ccff"
              />
            </g>
          </g>
        </g>
        <path
          data-name="Path 109754"
          d="M268.79 1636.2a28.647 28.647 0 01-14.13 5.043l-.526.038q-.914.057-1.841.057c-.666 0-1.33-.023-1.987-.066-.076 0-.15-.01-.223-.015a28.623 28.623 0 01-14.41-5.145l.312-1.334 2.117-9.051 11.651 2.614 2.617.586 2.464-.552 11.518-2.583 2.08 8.892z"
          transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(-47.838 -184.036)"
          fill="#7a67d9"
          opacity={0.67}
        />
        <path
          data-name="Path 109755"
          d="M231.206 1428.487a26.927 26.927 0 11-27.1-26.895h.2a27.244 27.244 0 013.79.265 26.882 26.882 0 0123.107 26.632z"
          fill="#d5ccff"
          transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065)"
        />
        <path
          data-name="Path 109756"
          d="M224.881 1426.66a22.413 22.413 0 1022.415 22.415 22.414 22.414 0 00-22.415-22.415z"
          transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(-20.572 -20.585)"
          fill="#f3f0ff"
        />
        <path
          data-name="Path 109757"
          d="M233.754 1478.794a20.986 20.986 0 1120.987-20.985 20.986 20.986 0 01-20.987 20.985z"
          transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(-29.03 -28.929)"
          fill="#5b48bd"
        />
        <path
          data-name="Path 109758"
          d="M232.977 1477.814a20.649 20.649 0 1120.651-20.648 20.65 20.65 0 01-20.651 20.648z"
          transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(-28.668 -28.677)"
          fill="#d5ccff"
        />
        <path
          data-name="Path 109759"
          d="M261.14 1469.94a15.251 15.251 0 1015.251 15.252 15.251 15.251 0 00-15.251-15.252zm0 26.688a11.438 11.438 0 1111.439-11.437 11.438 11.438 0 01-11.439 11.437z"
          transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(-56.226 -56.123)"
          fill="#5b48bd"
        />
        <path
          data-name="Path 109760"
          d="M257.758 1466.7a15.251 15.251 0 1015.251 15.251 15.251 15.251 0 00-15.251-15.251zm0 26.688a11.438 11.438 0 1111.442-11.438 11.438 11.438 0 01-11.442 11.437z"
          transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(-53.45 -53.462)"
          fill="#f3f0ff"
        />
        <g data-name="Group 123345">
          <path
            data-name="Path 109761"
            d="M209.53 1401.6l-23.519 39.591a26.682 26.682 0 01-2-4.789l20.359-34.269a27.018 27.018 0 015.16-.533z"
            transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(178.593 1401.592) translate(-184.012 -1401.6)"
            fill="#fff"
            opacity={0.17}
          />
        </g>
        <g data-name="Group 123346">
          <path
            data-name="Path 109762"
            d="M238.967 1404.826l-27.188 45.761a27.055 27.055 0 01-4.623-4.818l25.366-42.7a26.624 26.624 0 016.445 1.757z"
            transform="translate(-77.798 -112.187) rotate(-8 -8887.48 1251.065) translate(182.733 1401.855) translate(-207.156 -1403.074)"
            fill="#fff"
            opacity={0.14}
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function MembersUserIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 16.238,
    height: 17.591,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.238 17.591"
      {...rest}
      sx={rootSx}
    >
      <path
        d="M10.511 5a3.157 3.157 0 103.157 3.157A3.168 3.168 0 0010.511 5zm7.217 0a3.157 3.157 0 103.157 3.157A3.168 3.168 0 0017.728 5zm-7.217 1.353a1.8 1.8 0 11-1.8 1.8 1.794 1.794 0 011.8-1.8zm7.217 0a1.8 1.8 0 11-1.8 1.8 1.794 1.794 0 011.8-1.8zM7.579 12.217A1.58 1.58 0 006 13.8v4.285a4.5 4.5 0 007.5 3.37 5.428 5.428 0 01-.718-1.181 3.153 3.153 0 01-5.428-2.188V13.8a.226.226 0 01.226-.226h4.748a2.471 2.471 0 01.557-1.353zm7.217 0a1.589 1.589 0 00-1.579 1.583v4.285a4.511 4.511 0 109.021 0V13.8a1.589 1.589 0 00-1.579-1.579zm0 1.353h5.864a.215.215 0 01.226.226v4.285a3.157 3.157 0 11-6.315 0V13.8a.215.215 0 01.229-.23z"
        transform="translate(-6 -5)"
        fill="#0e1824"
      />
    </SvgIcon>
  );
}
export function AgreementIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 14.4,
    height: 18,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14.4 18"
      sx={rootSx}
      {...rest}
    >
      <path
        d="M10.025 4A2.035 2.035 0 008 6.025v13.95A2.035 2.035 0 0010.025 22h10.35a2.035 2.035 0 002.025-2.025v-9.45a.675.675 0 00-.2-.477l-.007-.007L16.352 4.2a.675.675 0 00-.477-.2zm0 1.35H15.2v3.825a2.035 2.035 0 002.025 2.025h3.825v8.775a.665.665 0 01-.675.675h-10.35a.665.665 0 01-.675-.675V6.025a.665.665 0 01.675-.675zm6.525.95l3.55 3.55h-2.875a.665.665 0 01-.675-.675zm-3.375 6.25a1.985 1.985 0 00-1.429.569 2.36 2.36 0 00-.6 1.681 4.725 4.725 0 00.766 2.558 1.887 1.887 0 01-.541.142.675.675 0 100 1.35A3.387 3.387 0 0013 18.426a2.929 2.929 0 001.521.424 1.972 1.972 0 001.258-.439 2.59 2.59 0 00.623-.823l.04-.076a1.905 1.905 0 00.434.846 1.726 1.726 0 001.245.493 1.511 1.511 0 001.256-.759 1.945 1.945 0 00.31-1.372.675.675 0 10-1.332.213.761.761 0 01-.113.428c-.085.132-.162.141-.121.141-.221 0-.227-.032-.262-.069a.91.91 0 01-.145-.333 4.853 4.853 0 00-.2-.7 1.161 1.161 0 00-.31-.455 1.062 1.062 0 00-.663-.246 1.248 1.248 0 00-.982.585 6.623 6.623 0 00-.359.677 1.415 1.415 0 01-.294.415.5.5 0 01-.39.123 1.471 1.471 0 01-.346-.092c.035-.044.1-.073.129-.118A4.384 4.384 0 0015.2 14.8a2.355 2.355 0 00-.6-1.679 1.985 1.985 0 00-1.425-.571zm0 1.35a.6.6 0 01.463.163.985.985 0 01.212.735 3.469 3.469 0 01-.633 1.7c-.045.062-.113.094-.162.152a3.535 3.535 0 01-.555-1.85.99.99 0 01.212-.737.6.6 0 01.463-.163z"
        transform="translate(-8 -4)"
        fill="#0e1824"
      />
    </SvgIcon>
  );
}
export function Crown(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 12.883,
    height: 9.263,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12.883 9.263"
      sx={rootSx}
      {...rest}
    >
      <path
        data-name="Path 96830"
        d="M9.594 6.811h-7.94L0 1.362l3.308 2.18L5.624 0 7.94 3.542l3.308-2.18z"
        transform="translate(-4 25) translate(4.817 -23.91)"
        fill="#ffc107"
      />
      <path
        data-name="Path 96831"
        d="M2.577 7.9h7.73v1.363h-7.73zM6.441 0A.6.6 0 005.8.545a.6.6 0 00.644.545.6.6 0 00.641-.545A.6.6 0 006.441 0zm5.8 1.362a.6.6 0 00-.644.545.653.653 0 001.288 0 .6.6 0 00-.646-.545zm-11.594 0A.6.6 0 000 1.907a.6.6 0 00.644.545.6.6 0 00.644-.545.6.6 0 00-.644-.545z"
        transform="translate(-4 25) translate(4 -25)"
        fill="#ff9800"
      />
    </SvgIcon>
  );
}

export function MembersUploadIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 21.526,
    height: 19.999,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21.526 19.999"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 105341" fill="#00705e">
        <path
          data-name="Path 96836"
          d="M8.242 21.019v-1.947h8.84a5.32 5.32 0 013.9-4.6 5.629 5.629 0 01.888-.181V8.364L17 3.5H8.242A1.96 1.96 0 006.3 5.444v4.867a1.946 1.946 0 00-1.947 1.946v4.867A1.946 1.946 0 006.3 19.072v1.947a1.959 1.959 0 001.946 1.946h9.371a6.261 6.261 0 01-.523-1.946zm5.84-3.894h-2.92v-4.868h.973v3.894h1.947zm2.584-2.855c.218.08 1.3.56 1.306 1.541a1.283 1.283 0 01-1.446 1.314 1.493 1.493 0 01-1.62-1.558h.949c0 .143.011.835.671.781a.508.508 0 00.5-.531c.022-.357-.319-.572-.679-.745-.505-.242-1.307-.542-1.321-1.49a1.293 1.293 0 011.484-1.324 1.421 1.421 0 011.47 1.465h-.943c0-.1.017-.679-.544-.679a.483.483 0 00-.523.545c.03.431.592.635.696.681zM8.242 5.444h7.788v3.893h3.893v.974H8.242zm0 9.979l-.717 1.7H6.3l1.26-2.454-1.24-2.412h1.216l.705 1.672.707-1.672h1.213l-1.234 2.414 1.262 2.454H8.961z"
          transform="translate(-4.349 -3.497)"
        />
        <path
          d="M20.175 13.983l-4.005 4.005h3v4.005h2v-4.005h3z"
          transform="translate(-4.349 -3.497) translate(1.695 1.503)"
        />
      </g>
    </SvgIcon>
  );
}

export function MembersDownloadIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 20,
    height: 20,
    color: '#00705e',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      {...rest}
      sx={rootSx}
    >
      <path
        d="M6.545 2a1.818 1.818 0 00-1.818 1.818v4.546h-.909A1.818 1.818 0 002 10.182v4.545a1.818 1.818 0 001.818 1.818h.909v1.818a1.818 1.818 0 001.818 1.818h7.429l-1.818-1.818H6.545v-1.818h9.091v-1.818a1.818 1.818 0 011.818-1.818h1.818V6.545L14.727 2zm0 1.818h7.273v3.637h3.636v.909H6.545zm-.909 6.364A1.818 1.818 0 017.455 12h-.91a.909.909 0 00-1.818 0v.909a.909.909 0 101.818 0h.909a1.818 1.818 0 11-3.636 0V12a1.818 1.818 0 011.818-1.818zm4.222 0a1.326 1.326 0 011.373 1.367h-.879c0-.094.016-.634-.508-.634a.453.453 0 00-.49.51c.026.4.558.593.655.636.2.075 1.21.524 1.218 1.44a1.2 1.2 0 01-1.351 1.227 1.4 1.4 0 01-1.513-1.456h.887c0 .134.011.78.627.73a.474.474 0 00.463-.5c.021-.334-.3-.534-.634-.7-.473-.227-1.22-.507-1.234-1.392a1.208 1.208 0 011.387-1.228zm2.141 0h.957l.854 3.315.859-3.315h.966l-1.23 4.545h-1.182zm5.455 4.545v3.636h-2.727L18.364 22 22 18.364h-2.727v-3.637z"
        transform="translate(-2 -2)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function NotificationCardIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 19.033,
    height: 19.894,
    color: '#007965',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19.033 19.894"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-notification"
        d="M13.1,4.008a6.259,6.259,0,0,0-5.857,6.3v2.982L6.152,15.48l-.006.012a1.454,1.454,0,0,0,1.3,2.047h3.486a2.462,2.462,0,0,0,4.923,0h3.486a1.455,1.455,0,0,0,1.3-2.047l-.006-.012-1.087-2.188V10.154A6.165,6.165,0,0,0,13.1,4.008Zm.058,1.229a4.912,4.912,0,0,1,5.162,4.918v3.282a.615.615,0,0,0,.064.274l1.146,2.306a.191.191,0,0,1-.186.292H7.445a.19.19,0,0,1-.185-.292h0L8.406,13.71a.615.615,0,0,0,.064-.274V10.311A5.024,5.024,0,0,1,13.155,5.237Zm-.992,12.3h2.462a1.231,1.231,0,0,1-2.462,0Z"
        transform="matrix(0.966, -0.259, 0.259, 0.966, -6.526, 1.822)"
        fill="currentcolor"
        stroke="currentcolor"
        strokeWidth="0.5"
      />
    </SvgIcon>
  );
}
export function AfterNoonIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 16,
    height: 16,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 105488">
        <path
          d="M11.84 3.966a.44.44 0 00-.047.012.381.381 0 00-.3.381v2.282a.38.38 0 10.759 0V4.358a.38.38 0 00-.415-.392zM6.432 6.2a.377.377 0 00-.3.268.383.383 0 00.107.386l1.616 1.619a.38.38 0 10.534-.535L6.776 6.32a.38.38 0 00-.308-.12zm10.768 0a.381.381 0 00-.225.119l-1.614 1.619a.38.38 0 10.534.535l1.613-1.617A.38.38 0 0017.2 6.2zm-5.325 1.963a3.805 3.805 0 103.795 3.805 3.8 3.8 0 00-3.795-3.805zm-7.7 3.425a.384.384 0 00.107.761h2.281a.381.381 0 100-.761H4.179zm12.9 0a.384.384 0 00.107.761h2.277a.381.381 0 100-.761h-2.378zm-9 3.758a.381.381 0 00-.225.119l-1.607 1.617a.38.38 0 10.534.535L8.389 16a.381.381 0 00-.273-.654zm7.471 0a.377.377 0 00-.3.268.383.383 0 00.107.386l1.613 1.617a.38.38 0 10.534-.535l-1.6-1.618a.379.379 0 00-.273-.119h-.071zM11.84 16.9a.441.441 0 00-.047.012.381.381 0 00-.3.381v2.283a.38.38 0 10.759 0V17.3a.38.38 0 00-.415-.392z"
          transform="translate(-5115 -18278) translate(5111.15 18274.035)"
          fill="#444b54"
        />
        <g
          data-name="Ellipse 129700"
          transform="translate(-5115 -18278) translate(5117.04 18280.041)"
          fill="#fcca3d"
          stroke="#444b54"
          strokeWidth={1}
        >
          <ellipse cx={5.96} cy={5.959} rx={5.96} ry={5.959} stroke="none" />
          <ellipse cx={5.96} cy={5.959} rx={5.46} ry={5.459} fill="none" />
        </g>
      </g>
    </SvgIcon>
  );
}
export function EveningIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 16,
    height: 16,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...rest}
      sx={rootSx}
    >
      <path
        data-name="Path 96909"
        d="M19 27.126C19 22.629 22.331 19 26.458 19s7.458 3.629 7.458 8.126z"
        transform="translate(-16 -16) translate(-2.458 -2.458)"
        fill="#f46e67"
      />
      <path
        data-name="Path 96910"
        d="M31.5 24.5a.491.491 0 01-.5-.5 7 7 0 10-14 0 .5.5 0 11-1 0 8 8 0 1116 0 .491.491 0 01-.5.5zm0 2.5h-15a.5.5 0 010-1h15a.5.5 0 010 1zm-3.333 2.5h-8.334a.5.5 0 010-1h8.333a.5.5 0 010 1zM24.833 32h-1.666a.5.5 0 110-1h1.667a.5.5 0 110 1z"
        fill="#444b54"
        transform="translate(-16 -16)"
      />
    </SvgIcon>
  );
}
export function SunriseIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 22.857,
    height: 12,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22.857 12"
      {...rest}
      sx={rootSx}
    >
      <path
        data-name="Path 96905"
        d="M29 55.9a6.9 6.9 0 0113.793 0z"
        transform="translate(-6 -26) translate(-18.468 -18.468)"
        fill="#fcca3d"
      />
      <path
        data-name="Path 96906"
        d="M28.266 36.837H24.9a7.323 7.323 0 00-1.773-4.256l2.384-2.4a.571.571 0 000-.828.589.589 0 00-.828 0l-2.4 2.384a7.453 7.453 0 00-4.256-1.773v-3.373a.591.591 0 10-1.182 0v3.369a7.323 7.323 0 00-4.256 1.773l-2.4-2.384a.585.585 0 10-.828.828l2.384 2.384a7.453 7.453 0 00-1.773 4.256H6.591a.591.591 0 000 1.182h21.675a.581.581 0 00.591-.591.565.565 0 00-.591-.571zm-10.837-5.714a6.345 6.345 0 016.286 5.714H11.143a6.345 6.345 0 016.286-5.714z"
        fill="#444b54"
        transform="translate(-6 -26)"
      />
    </SvgIcon>
  );
}
export function RefreshIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 16,
    height: 14,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="14.458"
      height="14.1"
      viewBox="0 0 14.458 14.1"
      {...rest}
      sx={rootSx}
    >
      <path
        id="icons8-refresh_1_"
        data-name="icons8-refresh (1)"
        d="M15.744,3.41a.7.7,0,0,0-.7.7V5.44A6.958,6.958,0,0,0,9.047,2a7.049,7.049,0,1,0,6.641,9.4.706.706,0,0,0-1.332-.465A5.64,5.64,0,1,1,9.047,3.41a5.548,5.548,0,0,1,4.822,2.82h-1.3a.7.7,0,1,0,0,1.41h3.172a.7.7,0,0,0,.7-.7V4.115A.7.7,0,0,0,15.744,3.41Z"
        transform="translate(-1.99 -2)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function TickIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 11.608,
    height: 8.436,
    color: '#007965',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11.608 8.436"
      {...rest}
      sx={rootSx}
    >
      <path
        d="M10.987.2a.4.4 0 00-.275.121L3.8 7.235.882 4.314a.4.4 0 10-.565.565l3.2 3.2a.4.4 0 00.565 0l7.2-7.2a.4.4 0 00-.29-.686z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.4}
      />
    </SvgIcon>
  );
}
export function Doctor(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 15,
    height: 16.25,
    color: '#239179',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 16.25"
      sx={rootSx}
      {...rest}
    >
      <path
        data-name="icons8-medical-doctor (1)"
        d="M8.5 0a5.824 5.824 0 00-2.6.449 1.8 1.8 0 00-.545.391 1.254 1.254 0 00-.2.332.7.7 0 00-.039.156l-.327 4.277v.1l-.039.43a.938.938 0 000 .117 3.75 3.75 0 107.5 0v-.119l-.371-4.8a.7.7 0 00-.039-.156 1.254 1.254 0 00-.2-.332 1.805 1.805 0 00-.54-.396A5.824 5.824 0 008.5 0zm0 10C4.374 10 1 11.941 1 13.691v2.559h15v-2.559c0-1.663-3.052-3.494-6.894-3.672C8.9 10 8.7 10 8.5 10zm0-8.75a4.79 4.79 0 012.031.312.381.381 0 01.117.078l.254 3.2C10.326 4.878 9.545 5 8.5 5s-1.826-.122-2.4-.156l.254-3.2a.381.381 0 01.117-.078A4.79 4.79 0 018.5 1.25zm-.508.625v.742H7.25v1.016h.742v.742h1.016v-.742h.742V2.617h-.742v-.742zm-1.367 9.531L8.227 15H2.25v-1.309c0-.466 1.594-1.828 4.375-2.285zm3.75 0c2.781.457 4.375 1.819 4.375 2.285V15H8.773z"
        transform="translate(-1)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function FitFreakIllustration(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 118,
    height: 118,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 118 118"
      sx={rootSx}
      {...rest}
    >
      <defs>
        <filter
          id="a"
          x={0}
          y={0}
          width={118}
          height={118}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy={3} />
          <feGaussianBlur stdDeviation={3} result="blur" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <clipPath id="b">
          <path
            data-name="Path 99325"
            d="M13.549 80.005Q-.017 65.823 0 46.764a42.461 42.461 0 016.98-23.5A49.434 49.434 0 0125.4 6.324 50.405 50.405 0 0149.541.19q18.629 0 31.545 12.282T94 45.5c0 13.828-4.446 25.053-13.334 34.508S60.694 94.19 47.423 94.19s-24.844-4.725-33.874-14.185z"
            transform="translate(0 -.19)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g data-name="Group 106359">
        <g
          transform="translate(-3604 -12935) translate(3604 12935)"
          filter="url(#a)"
        >
          <g
            data-name="jimmy-fermin-bqe0J0b26RQ-unsplash"
            transform="translate(9 6)"
            fill="#f3f8db"
            stroke="#facc15"
            strokeWidth={5}
          >
            <circle cx={50} cy={50} r={50} stroke="none" />
            <circle cx={50} cy={50} r={47.5} fill="none" />
          </g>
        </g>
        <g data-name="Group 106158">
          <g
            data-name="Group 106156"
            transform="translate(-3604 -12935) translate(3616 12941.811) translate(0 .19)"
            clipPath="url(#b)"
          >
            <g data-name="Group 106155">
              <g data-name="Group 106152">
                <g data-name="Group 106148">
                  <g data-name="Group 106141">
                    <path
                      data-name="Path 99304"
                      d="M67.94 119.867c-3.219-2.529-.23-17.017-.23-17.017H49.464s2.989 14.488-.23 17.017-27.593 2.3-25.294 26.672h69.294c2.3-24.373-22.075-24.143-25.294-26.672z"
                      transform="translate(10.888 10.756) translate(.748) translate(0 39.458) translate(-23.788 -102.85)"
                      fill="#f89b6a"
                    />
                    <path
                      data-name="Path 99305"
                      d="M93.826 118.419c-1.595-4.461.7-15.569.7-15.569H76.28a66.451 66.451 0 011.262 10.917c4.593 3.326 10.365 4.647 16.284 4.652z"
                      transform="translate(10.888 10.756) translate(.748) translate(0 39.458) translate(-50.603 -102.85)"
                      fill="#ef8050"
                    />
                  </g>
                  <g data-name="Group 106147">
                    <g data-name="Group 106142">
                      <path
                        data-name="Path 99306"
                        d="M55.073 82.635c.856 3.14 3.272 5.923 5.17 5.4s2.563-4.143 1.7-7.283-2.91-4.6-4.813-4.084-2.925 2.827-2.064 5.962z"
                        transform="translate(10.888 10.756) translate(.748) translate(14.94) translate(.21 8.648) translate(-54.76 -58.614)"
                        fill="#ef8050"
                      />
                      <path
                        data-name="Path 99307"
                        d="M126.9 82.635c-.856 3.14-3.272 5.923-5.17 5.4s-2.563-4.143-1.7-7.283 2.91-4.6 4.813-4.084 2.925 2.827 2.064 5.962z"
                        transform="translate(10.888 10.756) translate(.748) translate(14.94) translate(.21 8.648) translate(-87.909 -58.614)"
                        fill="#ef8050"
                      />
                      <path
                        data-name="Path 99308"
                        d="M62.74 58.256c0 11.494 7.1 23.224 15.868 23.224s15.868-11.73 15.868-23.224-7.1-18.4-15.868-18.4-15.868 6.906-15.868 18.4z"
                        transform="translate(10.888 10.756) translate(.748) translate(14.94) translate(.21 8.648) translate(-58.836 -39.86)"
                        fill="#f89b6a"
                      />
                    </g>
                    <g data-name="Group 106146" fill="#2c2429">
                      <g data-name="Group 106143">
                        <path
                          data-name="Path 99309"
                          d="M60.315 64.854l-1.5.117s-.46-8.276-2.529-7.816c0 0-4.6-11.5.347-16.9 5.5-6.006 8.966 1.5 8.966 1.5s-1.723 8.274-6.199 10.231l.92 12.879z"
                          transform="translate(10.888 10.756) translate(.748) translate(14.94) translate(.007 7.702) translate(-54.345 -37.926)"
                        />
                        <path
                          data-name="Path 99310"
                          d="M119.863 56.979s-.577 5.287 2.416 6.207v9.425l.92.23s1.839-9.425 1.839-14.141-5.175-1.727-5.175-1.727z"
                          transform="translate(10.888 10.756) translate(.748) translate(14.94) translate(.007 7.702) translate(-87.792 -47.181)"
                        />
                      </g>
                      <g data-name="Group 106145">
                        <path
                          data-name="Path 99311"
                          d="M71.046 36.391s4.828 8.853 19.087 8.046c0 0-9.656-1.727-13.569-7.014a23.4 23.4 0 0018.627 6.094l-1.839-2.646a6.059 6.059 0 007.474 2.759s1.267-15.06-14.6-19.658c-12.938-3.752-19.087 6.554-18.739 12.3s3.566.117 3.566.117z"
                          transform="translate(10.888 10.756) translate(.748) translate(14.94) translate(-61.043 -22.686)"
                        />
                        <g data-name="Group 106144">
                          <path
                            data-name="Path 99312"
                            d="M67.255 55.145c.294-.313.548-.651.807-.988s.494-.69.714-1.047.426-.729.616-1.1l.279-.562c.1-.186.166-.382.249-.572s.161-.386.225-.582l.205-.587a11.442 11.442 0 00.313-1.2c.039-.205.093-.4.122-.607l.088-.611c.064-.406.064-.822.1-1.233L71.237 43l.572 3.018a6.287 6.287 0 00.318 1.057 4.959 4.959 0 00.225.523 4.211 4.211 0 00.259.514c.1.166.181.337.284.5l.328.474c.205.328.484.6.719.9s.538.553.807.832.6.494.89.743a3.656 3.656 0 00.474.342l.484.323c.161.108.318.225.489.323l.518.279c.352.176.68.391 1.047.533l1.086.465a10.071 10.071 0 001.115.4l1.13.377 1.159.284c.386.1.773.21 1.164.289.788.137 1.58.274 2.372.435-.8-.029-1.609-.078-2.416-.132-.4-.034-.8-.108-1.2-.161l-1.2-.191-1.184-.293a9.77 9.77 0 01-1.177-.344l-1.154-.421c-.386-.137-.744-.347-1.12-.523l-.558-.274c-.181-.1-.352-.215-.528-.323a9.244 9.244 0 01-1.032-.69c-.323-.264-.66-.509-.969-.787-.293-.3-.607-.572-.885-.885a10.732 10.732 0 01-.773-.988l-.347-.523c-.113-.176-.205-.367-.308-.553a4.692 4.692 0 01-.279-.567 6.146 6.146 0 01-.24-.587 6.525 6.525 0 01-.328-1.262l.836-.034c-.054.435-.068.88-.152 1.311l-.117.646c-.039.215-.113.426-.166.636-.1.426-.264.836-.406 1.247a12.988 12.988 0 01-.538 1.189c-.1.191-.191.391-.308.572l-.333.558c-.24.362-.489.714-.758 1.052a11.211 11.211 0 01-1.787 1.846z"
                            transform="translate(10.888 10.756) translate(.748) translate(14.94) translate(-60.93 -32.816)"
                          />
                          <path
                            data-name="Path 99313"
                            d="M54.33 34.159a11.13 11.13 0 011.291-2.226 7.661 7.661 0 011.859-1.824 4.21 4.21 0 01.577-.333 5.739 5.739 0 01.621-.259 4.233 4.233 0 01.665-.147 3.519 3.519 0 01.68-.029 3.973 3.973 0 01.68.083 4.764 4.764 0 01.651.2 4.632 4.632 0 01.616.274c.2.1.386.225.582.337l-.46.157a11.13 11.13 0 011.14-2.367 12.155 12.155 0 016-4.906 13.827 13.827 0 012.529-.69 16.615 16.615 0 012.6-.245c.435 0 .871.01 1.3.034s.866.054 1.291.117a25.088 25.088 0 012.553.44c.411.093.822.2 1.247.328s.832.264 1.238.411.8.323 1.2.484c.391.191.788.357 1.164.567a18.566 18.566 0 012.2 1.37 20.8 20.8 0 011.986 1.653 19.931 19.931 0 013.238 3.986 18.716 18.716 0 012.094 4.647 18.876 18.876 0 00-1.061-2.3 20.955 20.955 0 00-1.33-2.147 22.134 22.134 0 00-3.336-3.747 20.467 20.467 0 00-1.971-1.527 19.769 19.769 0 00-2.162-1.242c-.367-.2-.753-.347-1.13-.523-.391-.147-.768-.318-1.164-.44s-.788-.264-1.184-.367-.8-.205-1.218-.3a24.243 24.243 0 00-2.456-.406c-.411-.059-.827-.068-1.242-.1s-.827-.024-1.242-.024a16.542 16.542 0 00-2.46.215 12.743 12.743 0 00-2.372.626 11.73 11.73 0 00-4.128 2.583 12.97 12.97 0 00-1.59 1.878 10.468 10.468 0 00-1.154 2.162l-.137.362-.323-.205c-.171-.108-.338-.235-.514-.328a4.666 4.666 0 00-.543-.269 4.569 4.569 0 00-.567-.2 4.027 4.027 0 00-.592-.093 3.473 3.473 0 00-.6 0 3.908 3.908 0 00-1.169.3 4.146 4.146 0 00-.553.274 7.458 7.458 0 00-1.893 1.639 12.9 12.9 0 00-1.448 2.1z"
                            transform="translate(10.888 10.756) translate(.748) translate(14.94) translate(-54.33 -22.18)"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g data-name="Group 106151">
                  <g data-name="Group 106149" fill="#db5223">
                    <path
                      data-name="Path 99314"
                      d="M56.112 83.557a5.738 5.738 0 01.034-1.228 2.819 2.819 0 01.147-.616 1.245 1.245 0 01.406-.6.709.709 0 01.435-.122.9.9 0 01.4.122 1.86 1.86 0 01.166.108 1.048 1.048 0 01.122.1 2 2 0 01.24.284 4.857 4.857 0 01.553 1.164 13.369 13.369 0 01.533 2.4 20.181 20.181 0 01.191 2.431v.147l-.1.064a2.005 2.005 0 00-.289.225 1.315 1.315 0 00-.225.274.459.459 0 00.039.577 1.781 1.781 0 00.641.43 6.957 6.957 0 00.773.289 5.411 5.411 0 01-.827-.142 1.962 1.962 0 01-.788-.382.8.8 0 01-.254-.435.884.884 0 01.073-.509 1.718 1.718 0 01.254-.4 2.318 2.318 0 01.333-.323l-.1.21c-.113-.787-.24-1.58-.377-2.362-.068-.391-.142-.783-.23-1.164s-.171-.768-.284-1.14a4.928 4.928 0 00-.416-1.042c-.049-.073-.1-.142-.132-.191a.921.921 0 00-.1-.1.7.7 0 00-.078-.064c-.132-.088-.21-.108-.3-.064a.839.839 0 00-.3.357 4.765 4.765 0 00-.225.528 10.883 10.883 0 00-.308 1.159z"
                      transform="translate(10.888 10.756) translate(.748) translate(15.803 22.245) translate(0 6.519) translate(-56.094 -80.987)"
                    />
                    <path
                      data-name="Path 99315"
                      d="M129.46 83.567a10.88 10.88 0 00-.308-1.159 3.43 3.43 0 00-.225-.528.874.874 0 00-.3-.357c-.093-.044-.171-.024-.3.064a.7.7 0 00-.078.064.921.921 0 00-.1.1c-.034.049-.083.117-.132.191a4.728 4.728 0 00-.416 1.042c-.112.372-.205.753-.284 1.14s-.161.773-.23 1.164a78.386 78.386 0 00-.377 2.362l-.1-.21a2.317 2.317 0 01.333.323 1.733 1.733 0 01.259.4.884.884 0 01.073.509.829.829 0 01-.254.435 1.842 1.842 0 01-.788.382 5.412 5.412 0 01-.827.142 6.959 6.959 0 00.773-.289 1.966 1.966 0 00.641-.43.452.452 0 00.039-.577 1.314 1.314 0 00-.225-.274 2.005 2.005 0 00-.289-.225l-.1-.064v-.147a21.237 21.237 0 01.2-2.431 13.8 13.8 0 01.533-2.4 4.678 4.678 0 01.553-1.164 2 2 0 01.24-.284c.049-.049.083-.068.122-.1a1.034 1.034 0 01.166-.108.993.993 0 01.4-.122.709.709 0 01.435.122 1.258 1.258 0 01.406.6 3.133 3.133 0 01.147.616 5.739 5.739 0 01.034 1.228z"
                      transform="translate(10.888 10.756) translate(.748) translate(15.803 22.245) translate(0 6.519) translate(-91.499 -80.998)"
                    />
                  </g>
                  <g data-name="Group 106150">
                    <path
                      data-name="Path 99316"
                      d="M95.9 77.47c-.01.9 0 1.771.054 2.641.024.435.054.866.108 1.3s.1.856.181 1.272a11.713 11.713 0 00.279 1.242c.064.2.117.406.186.6s.142.4.22.587a10.813 10.813 0 00.563 1.115 9.158 9.158 0 00.743 1l.289.337-.338.2c-.523.308-1.057.6-1.59.89s-1.076.567-1.634.822c.455-.416.924-.8 1.4-1.184s.954-.753 1.443-1.11l-.049.538c-.171-.161-.347-.313-.5-.489a6.737 6.737 0 01-.44-.548 6.645 6.645 0 01-.695-1.213 8.477 8.477 0 01-.465-1.306 11.542 11.542 0 01-.264-1.35 12.6 12.6 0 01-.034-2.715c.049-.45.108-.9.2-1.335a9.073 9.073 0 01.357-1.3z"
                      transform="translate(10.888 10.756) translate(.748) translate(15.803 22.245) translate(6.372) translate(-82.32 -72.671)"
                      fill="#db5223"
                    />
                    <path
                      data-name="Path 99317"
                      d="M85.115 106.6s.675.181 1.663.386c.249.044.514.1.8.147s.582.088.885.132.626.049.944.1c.323.01.651.039.973.024a7.976 7.976 0 00.969-.044c.157-.02.318-.034.474-.044s.3-.054.455-.078.3-.059.445-.078c.142-.039.279-.078.416-.112a5.376 5.376 0 00.763-.235q.352-.132.646-.235c.181-.093.347-.166.479-.23.274-.127.44-.191.44-.191s-.117.127-.333.342c-.108.108-.245.24-.406.382s-.372.264-.6.411a3.83 3.83 0 01-.758.406c-.142.064-.284.127-.435.191s-.313.093-.474.137a5.243 5.243 0 01-1.013.215 8.483 8.483 0 01-1.066.078c-.357 0-.709-.039-1.061-.059-.347-.054-.685-.1-1.008-.186a6.91 6.91 0 01-.915-.264 7.565 7.565 0 01-.788-.308 6.612 6.612 0 01-1.5-.885z"
                      transform="translate(10.888 10.756) translate(.748) translate(15.803 22.245) translate(6.372) translate(-77.288 -87.318)"
                      fill="#db5223"
                    />
                    <path
                      data-name="Path 99318"
                      d="M98.28 71.538a.544.544 0 01.029-.147 2.8 2.8 0 01.122-.406 4.287 4.287 0 01.269-.6 5.051 5.051 0 01.474-.724 5.72 5.72 0 01.719-.763 5.077 5.077 0 01.47-.347c.083-.059.166-.112.249-.171s.186-.093.279-.142a4.88 4.88 0 01.587-.264c.21-.064.426-.127.641-.181a3.078 3.078 0 01.67-.1 5.269 5.269 0 01.68-.029l.67.078c.113.015.22.024.333.049l.313.1a5.381 5.381 0 011.169.455 7.2 7.2 0 01.978.592c.279.225.538.445.768.651a3.846 3.846 0 01.567.621c.161.191.289.372.391.518a5.451 5.451 0 01.308.47s-.205-.059-.538-.186c-.166-.064-.367-.137-.582-.235a7.155 7.155 0 00-.734-.293c-.269-.1-.553-.205-.846-.328s-.616-.181-.929-.293a8.215 8.215 0 00-.969-.235l-.245-.059-.245-.02-.489-.049a3.2 3.2 0 00-.484.01 2.6 2.6 0 00-.479.029c-.157.029-.313.054-.47.068s-.3.088-.455.122l-.225.059a9.496 9.496 0 01-.215.088c-.142.059-.289.1-.426.166-.269.137-.538.249-.768.4-.245.127-.455.279-.655.4-.181.142-.367.249-.5.357s-.254.186-.328.245l-.117.093z"
                      transform="translate(10.888 10.756) translate(.748) translate(15.803 22.245) translate(6.372) translate(-84.011 -67.659)"
                      fill="#161114"
                    />
                    <path
                      data-name="Path 99319"
                      d="M69.13 71.538a.544.544 0 01.029-.147 2.8 2.8 0 01.122-.406 4.286 4.286 0 01.269-.6 5.049 5.049 0 01.474-.724 5.719 5.719 0 01.719-.763 5.077 5.077 0 01.47-.347c.083-.059.166-.112.249-.171s.186-.093.279-.142a4.881 4.881 0 01.587-.264c.21-.064.426-.127.641-.181a3.078 3.078 0 01.67-.1 5.269 5.269 0 01.68-.029l.67.078c.113.015.22.024.333.049l.313.1a5.38 5.38 0 011.169.455 7.2 7.2 0 01.978.592c.279.225.538.445.768.651a3.846 3.846 0 01.567.621c.161.191.289.372.391.518a5.454 5.454 0 01.308.47s-.205-.059-.538-.186c-.166-.064-.367-.137-.582-.235a7.152 7.152 0 00-.734-.293c-.269-.1-.553-.205-.846-.328s-.616-.181-.929-.293a8.215 8.215 0 00-.969-.235l-.245-.059-.245-.02-.489-.049a3.2 3.2 0 00-.484.01 2.6 2.6 0 00-.479.029c-.157.029-.313.054-.47.068s-.3.088-.455.122l-.225.059a9.496 9.496 0 01-.215.088c-.142.059-.289.1-.426.166-.269.137-.538.249-.768.4-.245.127-.455.279-.655.4-.181.142-.367.249-.5.357s-.254.186-.328.245l-.117.093z"
                      transform="translate(10.888 10.756) translate(.748) translate(15.803 22.245) translate(6.372) translate(-69.12 -67.659)"
                      fill="#161114"
                    />
                    <path
                      data-name="Path 99320"
                      d="M81.026 79.88c0 1.247-.347 2.26-.773 2.26s-.773-1.012-.773-2.26.347-2.26.773-2.26.773 1.012.773 2.26z"
                      transform="translate(10.888 10.756) translate(.748) translate(15.803 22.245) translate(6.372) translate(-74.412 -72.748)"
                      fill="#161114"
                    />
                    <path
                      data-name="Path 99321"
                      d="M108.586 79.26c0 1.247-.347 2.26-.773 2.26s-.773-1.012-.773-2.26.347-2.26.773-2.26.773 1.012.773 2.26z"
                      transform="translate(10.888 10.756) translate(.748) translate(15.803 22.245) translate(6.372) translate(-88.491 -72.431)"
                      fill="#161114"
                    />
                  </g>
                </g>
              </g>
              <g data-name="Group 106154">
                <path
                  data-name="Path 99322"
                  d="M72.069 139.05s-2.578 7.983-14.264 8.046c-11.686-.064-14.264-8.046-14.264-8.046-26.441 5.75-20.773 25.982-20.773 25.982l34.9.23h.274l34.9-.23s5.666-20.232-20.773-25.982z"
                  transform="translate(10.888 10.756) translate(0 56.636) translate(-22.258 -138.522)"
                  fill="#c1db4d"
                />
                <g data-name="Group 106153" fill="#d84848">
                  <path
                    data-name="Path 99323"
                    d="M46.622 137.97l4.637 26.814-17.409-.205v-19.693a47.724 47.724 0 0112.772-6.916z"
                    transform="translate(10.888 10.756) translate(0 56.636) translate(5.67) translate(-33.85 -137.97)"
                  />
                  <path
                    data-name="Path 99324"
                    d="M124.772 137.97l-4.622 26.814 17.394-.205v-19.693a47.724 47.724 0 00-12.772-6.916z"
                    transform="translate(10.888 10.756) translate(0 56.636) translate(5.67) translate(-77.936 -137.97)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function RippedIllustration(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 75,
    height: 75,
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 75 75"
      sx={rootSx}
      {...rest}
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Path 99182"
            d="M476.993 222.571a33.746 33.746 0 0123.722 9.757 29.558 29.558 0 018.375 15.1 33.874 33.874 0 01-.754 17.521 35.146 35.146 0 01-9.122 15 31.955 31.955 0 01-22.22 9.545q-12.775.308-23.291-9.966-10.309-10.075-10.734-23.709t9.659-23.5a32.559 32.559 0 0124.365-9.748z"
            transform="translate(-444.37 -223.981)"
            fill="none"
          />
        </clipPath>
        <clipPath id="b">
          <path
            data-name="Path 99164"
            d="M497.035 360.02s-1.716 5.315-9.5 5.358c-7.781-.042-9.5-5.358-9.5-5.358-17.6 3.827-13.833 17.3-13.833 17.3l23.239.153h.182l23.239-.153s3.772-13.474-13.832-17.3z"
            transform="translate(-463.868 -360.02)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g data-name="Group 106362">
        <g
          data-name="Ellipse 129809"
          transform="translate(-3555 -12966) translate(3555 12966)"
          fill="#faebeb"
          stroke="#d5ccff"
          strokeWidth={3}
        >
          <circle cx={37.5} cy={37.5} r={37.5} stroke="none" />
          <circle cx={37.5} cy={37.5} r={36} fill="none" />
        </g>
        <g data-name="Group 106159">
          <g
            data-name="Group 106066"
            transform="translate(-3555 -12966) translate(3118.719 12752.107) translate(441.174 220.785)"
            clipPath="url(#a)"
          >
            <g data-name="Group 106065">
              <g data-name="Group 106054">
                <g data-name="Group 106050">
                  <path
                    data-name="Path 99161"
                    d="M494.8 335.151c-2.143-1.684-.153-11.331-.153-11.331h-12.152s1.99 9.647-.153 11.331-18.373 1.531-16.842 17.761h46.139c1.53-16.23-14.699-16.077-16.839-17.761z"
                    transform="translate(8.44 6.572) translate(0 29.035) translate(.498) translate(-465.398 -323.82)"
                    fill="#f89b6a"
                  />
                  <path
                    data-name="Path 99162"
                    d="M529.573 334.2c-1.062-2.97.466-10.367.466-10.367H517.89a44.248 44.248 0 01.84 7.27 18.332 18.332 0 0010.843 3.097z"
                    transform="translate(8.44 6.572) translate(0 29.035) translate(.498) translate(-500.793 -323.827)"
                    fill="#ef8050"
                  />
                </g>
                <g data-name="Group 106053">
                  <path
                    data-name="Path 99163"
                    d="M497.035 360.02s-1.716 5.315-9.5 5.358c-7.781-.042-9.5-5.358-9.5-5.358-17.6 3.827-13.833 17.3-13.833 17.3l23.239.153h.182l23.239-.153s3.772-13.474-13.832-17.3z"
                    transform="translate(8.44 6.572) translate(0 29.035) translate(0 11.79) translate(-463.868 -360.02)"
                    fill="#d84848"
                  />
                  <g
                    data-name="Group 106052"
                    clipPath="url(#b)"
                    transform="translate(8.44 6.572) translate(0 29.035) translate(0 11.79)"
                  >
                    <g
                      data-name="Group 106051"
                      transform="translate(-3.979 1.847)"
                      fill="#fff"
                    >
                      <path
                        data-name="Rectangle 56140"
                        d="M0 0H54.575V1.462H0z"
                      />
                      <path
                        data-name="Rectangle 56141"
                        transform="translate(0 4.133)"
                        d="M0 0H54.575V1.462H0z"
                      />
                      <path
                        data-name="Rectangle 56142"
                        transform="translate(0 8.27)"
                        d="M0 0H54.575V1.462H0z"
                      />
                      <path
                        data-name="Rectangle 56143"
                        transform="translate(0 12.403)"
                        d="M0 0H54.575V1.462H0z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g data-name="Group 106064">
                <g data-name="Group 106060">
                  <g data-name="Group 106055">
                    <path
                      data-name="Path 99165"
                      d="M496.578 301.589c.57 2.091 2.179 3.944 3.443 3.6s1.707-2.759 1.133-4.85-1.938-3.065-3.2-2.72-1.948 1.882-1.374 3.97z"
                      transform="translate(8.44 6.572) translate(9.105) translate(1.481 8.519) translate(-496.37 -285.591)"
                      fill="#ef8050"
                    />
                    <path
                      data-name="Path 99166"
                      d="M566.085 301.589c-.57 2.091-2.179 3.944-3.443 3.6s-1.707-2.759-1.134-4.85 1.938-3.065 3.205-2.72 1.948 1.882 1.374 3.97z"
                      transform="translate(8.44 6.572) translate(9.105) translate(1.481 8.519) translate(-540.126 -285.591)"
                      fill="#ef8050"
                    />
                    <path
                      data-name="Path 99167"
                      d="M504.35 273.08c0 7.654 4.729 15.464 10.566 15.464s10.566-7.81 10.566-15.464-4.729-12.25-10.566-12.25-10.566 4.596-10.566 12.25z"
                      transform="translate(8.44 6.572) translate(9.105) translate(1.481 8.519) translate(-501.751 -260.83)"
                      fill="#f89b6a"
                    />
                  </g>
                  <g data-name="Group 106059" fill="#723021">
                    <g data-name="Group 106056">
                      <path
                        data-name="Path 99168"
                        d="M497.143 277.142l-1 .078s-.306-5.511-1.684-5.2c0 0-5.332-7.56-.844-11.338 4.15-3.495 7.045 1.081 7.045 1.081s-1.15 5.511-4.133 6.814l.612 8.576z"
                        transform="translate(8.44 6.572) translate(9.105) translate(0 8.041) translate(-491.822 -259.362)"
                      />
                      <path
                        data-name="Path 99169"
                        d="M561.19 277.643a1.681 1.681 0 001.189 2.381l.42 8.032.612.153a69.813 69.813 0 001.225-9.416c0-3.14-3.446-1.15-3.446-1.15z"
                        transform="translate(8.44 6.572) translate(9.105) translate(0 8.041) translate(-538.489 -271.269)"
                      />
                    </g>
                    <g data-name="Group 106058">
                      <path
                        data-name="Path 99170"
                        d="M529.984 245.784c-2.547-.945 3.544-4.371-.944-6.615s-4.133 2.482-8.149.71-11.1-3.544-11.93 6.5l2.361 1.534s.176.137.5.368c1.984 1.417 12.256 8.419 18.4 5.182 4.488-2.363 2.954-6.5-.238-7.679z"
                        transform="translate(8.44 6.572) translate(9.105) translate(5.582) translate(-508.96 -237.258)"
                      />
                      <g data-name="Group 106057">
                        <path
                          data-name="Path 99171"
                          d="M521.273 266.86l.925.6a59.275 59.275 0 004.169 2.423c.602.322 1.251.635 1.922.954s1.381.609 2.107.892a20.814 20.814 0 002.234.726 14.393 14.393 0 002.286.449 10.935 10.935 0 002.234.026 7.207 7.207 0 002.013-.492l.228-.091c.062-.026.147-.072.218-.108.153-.072.3-.15.427-.225a5.988 5.988 0 00.752-.492 4.463 4.463 0 001.075-1.146 3.414 3.414 0 00.459-1.13 3.624 3.624 0 00.072-.8l-.02-.287.059.283a3.129 3.129 0 01.026.821 3.559 3.559 0 01-.365 1.241 4.31 4.31 0 01-1.045 1.329 6.326 6.326 0 01-.772.589 4.626 4.626 0 01-.433.261c-.075.042-.137.078-.228.127s-.16.075-.241.111a6.954 6.954 0 01-2.15.629 10.372 10.372 0 01-2.381.036 15.184 15.184 0 01-2.4-.446 21.65 21.65 0 01-2.3-.775 26.73 26.73 0 01-2.13-.967 33.215 33.215 0 01-3.553-2.1c-1-.674-1.791-1.293-2.345-1.726s-.847-.707-.847-.707z"
                          transform="translate(8.44 6.572) translate(9.105) translate(5.582) translate(.112) translate(-517.373 -256.377)"
                        />
                        <path
                          data-name="Path 99172"
                          d="M528.705 235.271l-.28-.075a22.774 22.774 0 01-.339-.088l-.215-.055c-.078-.01-.16-.023-.244-.036A3.475 3.475 0 00526.4 235a2.851 2.851 0 00-1.394.671 10.1 10.1 0 01-1.567 1.234 2.493 2.493 0 01-.534.221c-.094.026-.192.052-.287.081a2.23 2.23 0 01-.3.033l-.3.026c-.1 0-.2-.016-.3-.023a3.283 3.283 0 01-.6-.088l-.583-.15c-.195-.05-.371-.117-.55-.169-.365-.107-.743-.2-1.12-.3a13.937 13.937 0 00-2.316-.365 8.442 8.442 0 00-2.3.117 5.389 5.389 0 00-2.019.824 5.217 5.217 0 00-1.417 1.479 7.893 7.893 0 00-.8 1.707 13.778 13.778 0 00-.4 1.576c-.039.241-.081.466-.111.674s-.046.4-.065.58c-.039.349-.055.625-.072.814s-.023.29-.023.29-.007-.1-.016-.29-.036-.469-.026-.821c0-.179.007-.375.01-.59s.029-.446.046-.694.062-.508.091-.788.111-.563.176-.866a7.521 7.521 0 01.743-1.87 5.457 5.457 0 011.508-1.713 5.751 5.751 0 012.241-.987 9.14 9.14 0 012.492-.153 14.9 14.9 0 012.43.407c.394.1.775.208 1.153.336.192.059.371.124.554.189.176.049.349.1.521.15a2.831 2.831 0 001.935-.111 11.968 11.968 0 001.563-1.088c.134-.085.257-.176.394-.247s.27-.137.4-.192c.14-.039.277-.081.41-.117a3.492 3.492 0 01.4-.049 3.757 3.757 0 011.3.143l.248.062.205.085.323.13.27.111z"
                          transform="translate(8.44 6.572) translate(9.105) translate(5.582) translate(.112) translate(-509.304 -234.712)"
                        />
                        <path
                          data-name="Path 99173"
                          d="M521.023 235.05s-.277-.016-.759-.026-1.166-.013-1.98.046a14.038 14.038 0 00-2.72.453 9.643 9.643 0 00-1.433.531 6.329 6.329 0 00-1.309.834 4.881 4.881 0 00-1.039 1.13 2.536 2.536 0 00-.2.322c-.062.111-.13.215-.186.329a5.479 5.479 0 00-.29.687 7.573 7.573 0 00-.352 1.384 11.847 11.847 0 00-.12 1.3c-.016.2 0 .4-.007.583s-.007.365.01.528c.026.332.026.625.055.863.046.479.068.756.068.756s-.078-.264-.205-.733c-.065-.234-.114-.524-.182-.857a10.106 10.106 0 01-.137-1.133c-.007-.208-.029-.43-.026-.658s.01-.463.029-.707a7.026 7.026 0 01.287-1.515 5.76 5.76 0 011.856-2.808 7.137 7.137 0 011.466-.9 8.6 8.6 0 011.563-.515 10.347 10.347 0 011.5-.228 12.1 12.1 0 011.355-.033 12.933 12.933 0 012 .215c.238.042.423.088.55.117l.192.046z"
                          transform="translate(8.44 6.572) translate(9.105) translate(5.582) translate(.112) translate(-509.914 -234.674)"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g data-name="Group 106063">
                  <g data-name="Group 106061" fill="#db5223">
                    <path
                      data-name="Path 99174"
                      d="M497.716 303.678a3.823 3.823 0 01.023-.818 1.879 1.879 0 01.1-.41.829.829 0 01.27-.4.472.472 0 01.29-.081.6.6 0 01.264.081 1.25 1.25 0 01.111.072c.026.023.049.036.081.068a1.332 1.332 0 01.16.189 3.237 3.237 0 01.368.775 8.9 8.9 0 01.355 1.6 13.43 13.43 0 01.127 1.619v.1l-.068.042a1.34 1.34 0 00-.192.15.878.878 0 00-.15.182.305.305 0 00.026.384 1.186 1.186 0 00.427.287 4.626 4.626 0 00.515.192 3.6 3.6 0 01-.55-.094 1.306 1.306 0 01-.524-.254.532.532 0 01-.169-.29.589.589 0 01.049-.339 1.056 1.056 0 01.173-.264 1.548 1.548 0 01.221-.215l-.068.14a51.978 51.978 0 00-.251-1.573c-.046-.261-.094-.521-.153-.775s-.114-.511-.189-.759a3.281 3.281 0 00-.277-.694l-.088-.127a.61.61 0 00-.065-.068.458.458 0 00-.052-.042c-.088-.059-.14-.072-.2-.042a.559.559 0 00-.2.238 3.172 3.172 0 00-.15.352 7.241 7.241 0 00-.205.772z"
                      transform="translate(8.44 6.572) translate(9.105) translate(1.916 17.573) translate(0 4.344) translate(-497.704 -301.967)"
                    />
                    <path
                      data-name="Path 99175"
                      d="M569.713 303.692a7.245 7.245 0 00-.205-.772 2.292 2.292 0 00-.15-.352.581.581 0 00-.2-.238c-.062-.029-.114-.016-.2.042a.451.451 0 00-.052.042.607.607 0 00-.065.068l-.088.127a3.142 3.142 0 00-.277.694c-.075.248-.137.5-.189.759s-.108.515-.153.775a51.978 51.978 0 00-.251 1.573l-.068-.14a1.547 1.547 0 01.221.215 1.156 1.156 0 01.173.264.589.589 0 01.049.339.551.551 0 01-.169.29 1.226 1.226 0 01-.524.254 3.611 3.611 0 01-.55.094 4.648 4.648 0 00.515-.192 1.31 1.31 0 00.427-.287.3.3 0 00.026-.384.875.875 0 00-.15-.182 1.33 1.33 0 00-.192-.15l-.068-.042v-.1a14.143 14.143 0 01.13-1.619 9.181 9.181 0 01.355-1.6 3.115 3.115 0 01.368-.775 1.314 1.314 0 01.159-.189c.033-.033.055-.046.081-.068a.685.685 0 01.111-.072.644.644 0 01.264-.081.472.472 0 01.29.081.837.837 0 01.27.4 2.087 2.087 0 01.1.41 3.819 3.819 0 01.023.817z"
                      transform="translate(8.44 6.572) translate(9.105) translate(1.916 17.573) translate(0 4.344) translate(-544.437 -301.981)"
                    />
                  </g>
                  <g data-name="Group 106062">
                    <path
                      data-name="Path 99176"
                      d="M537.189 298.44c-.007.6 0 1.179.036 1.759.016.29.036.576.072.863s.065.57.12.847a7.793 7.793 0 00.186.827c.042.134.078.27.124.4s.094.264.147.391a7.182 7.182 0 00.375.743 6.184 6.184 0 00.492.668l.192.225-.225.134c-.349.205-.7.4-1.059.593s-.717.378-1.088.547c.3-.277.616-.531.932-.788s.635-.5.961-.739l-.033.358c-.114-.107-.231-.208-.336-.326a4.487 4.487 0 01-.293-.365 4.613 4.613 0 01-.463-.808 5.647 5.647 0 01-.309-.87 7.7 7.7 0 01-.176-.9 8.384 8.384 0 01-.023-1.808 8.991 8.991 0 01.133-.889 6.048 6.048 0 01.238-.863z"
                      transform="translate(8.44 6.572) translate(9.105) translate(1.916 17.573) translate(4.243) translate(-528.147 -295.245)"
                      fill="#db5223"
                    />
                    <path
                      data-name="Path 99177"
                      d="M526.723 327.426s.449.121 1.107.257c.166.029.342.068.531.1s.388.059.59.088.417.033.629.065c.215.007.433.026.648.016a5.3 5.3 0 00.645-.029c.1-.013.212-.023.316-.029s.2-.036.3-.052.2-.039.3-.052.186-.052.277-.075a3.574 3.574 0 00.508-.156q.235-.088.43-.156c.121-.062.231-.111.319-.153.182-.085.293-.127.293-.127s-.078.085-.221.228c-.072.072-.163.16-.27.254s-.248.176-.4.274a2.548 2.548 0 01-.5.27c-.094.042-.189.085-.29.127s-.208.062-.316.091a3.492 3.492 0 01-.674.143 5.649 5.649 0 01-.71.052c-.238 0-.472-.026-.707-.039-.231-.036-.456-.068-.671-.124a4.594 4.594 0 01-.609-.176 5.014 5.014 0 01-.524-.205 4.4 4.4 0 01-1-.589z"
                      transform="translate(8.44 6.572) translate(9.105) translate(1.916 17.573) translate(4.243) translate(-521.512 -314.583)"
                      fill="#db5223"
                    />
                    <path
                      data-name="Path 99178"
                      d="M539.887 291.212a.363.363 0 01.02-.1 1.868 1.868 0 01.081-.27 2.858 2.858 0 01.179-.4 3.362 3.362 0 01.316-.482 3.8 3.8 0 01.479-.508 3.381 3.381 0 01.313-.231c.055-.039.111-.075.166-.114s.124-.062.186-.094a3.235 3.235 0 01.391-.176c.14-.042.283-.085.427-.121a2.052 2.052 0 01.446-.065 3.523 3.523 0 01.453-.02l.446.052c.075.01.147.016.221.033l.208.065a3.583 3.583 0 01.779.3 4.789 4.789 0 01.651.394c.186.15.358.3.511.433a2.553 2.553 0 01.378.414c.108.127.192.248.26.345a3.616 3.616 0 01.205.313s-.137-.039-.358-.124c-.111-.042-.244-.091-.388-.156a4.755 4.755 0 00-.489-.2c-.179-.065-.368-.137-.563-.218s-.41-.121-.619-.2a5.465 5.465 0 00-.645-.156l-.163-.039-.163-.013-.326-.033a2.134 2.134 0 00-.322.006 1.737 1.737 0 00-.319.02c-.1.02-.208.036-.313.046s-.2.059-.3.081l-.15.039-.143.059c-.094.039-.192.068-.283.111a5.343 5.343 0 00-.511.264c-.163.085-.3.186-.436.267s-.244.166-.332.238-.169.124-.218.163l-.078.062z"
                      transform="translate(8.44 6.572) translate(9.105) translate(1.916 17.573) translate(4.243) translate(-530.386 -288.629)"
                      fill="#161114"
                    />
                    <path
                      data-name="Path 99179"
                      d="M510.736 291.212a.362.362 0 01.02-.1 1.867 1.867 0 01.081-.27 2.865 2.865 0 01.179-.4 3.372 3.372 0 01.316-.482 3.807 3.807 0 01.479-.508 3.355 3.355 0 01.313-.231c.055-.039.111-.075.166-.114s.124-.062.186-.094a3.253 3.253 0 01.391-.176c.14-.042.283-.085.427-.121a2.052 2.052 0 01.446-.065 3.522 3.522 0 01.453-.02l.446.052c.075.01.147.016.222.033l.208.065a3.583 3.583 0 01.778.3 4.793 4.793 0 01.651.394c.186.15.358.3.511.433a2.555 2.555 0 01.378.414c.108.127.192.248.261.345a3.642 3.642 0 01.205.313s-.137-.039-.358-.124c-.111-.042-.244-.091-.388-.156a4.748 4.748 0 00-.489-.2c-.179-.065-.368-.137-.563-.218s-.41-.121-.619-.2a5.461 5.461 0 00-.645-.156l-.163-.039-.163-.013-.326-.033a2.134 2.134 0 00-.322.006 1.737 1.737 0 00-.319.02c-.1.02-.208.036-.313.046s-.2.059-.3.081l-.15.039-.143.059c-.094.039-.192.068-.283.111a5.358 5.358 0 00-.511.264c-.163.085-.3.186-.436.267s-.244.166-.332.238-.169.124-.218.163l-.078.062z"
                      transform="translate(8.44 6.572) translate(9.105) translate(1.916 17.573) translate(4.243) translate(-510.73 -288.629)"
                      fill="#161114"
                    />
                    <path
                      data-name="Path 99180"
                      d="M522.119 300.1c0 .831-.231 1.5-.515 1.5s-.515-.674-.515-1.5.231-1.5.515-1.5.515.674.515 1.5z"
                      transform="translate(8.44 6.572) translate(9.105) translate(1.916 17.573) translate(4.243) translate(-517.716 -295.352)"
                      fill="#161114"
                    />
                    <path
                      data-name="Path 99181"
                      d="M549.679 299.475c0 .831-.231 1.5-.515 1.5s-.515-.674-.515-1.5.231-1.5.515-1.5.515.669.515 1.5z"
                      transform="translate(8.44 6.572) translate(9.105) translate(1.916 17.573) translate(4.243) translate(-536.299 -294.928)"
                      fill="#161114"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function FlexyIllustration(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 75,
    height: 75,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 75 75"
      sx={rootSx}
      {...rest}
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Path 99384"
            d="M218.878 36.04a35.289 35.289 0 0110.2-24.8 30.909 30.909 0 0115.795-8.757 35.442 35.442 0 0118.32.789 36.668 36.668 0 0115.685 9.539 33.415 33.415 0 019.98 23.231q.324 13.358-10.419 24.353-10.53 10.774-24.789 11.225t-24.573-10.1a34.364 34.364 0 01-10.2-25.479z"
            fill="none"
          />
        </clipPath>
        <clipPath id="b">
          <path
            data-name="Path 99383"
            d="M301.831 141.8a19.006 19.006 0 00-5.169-1.928s-1.978 6.124-10.945 6.174c-8.964-.05-10.945-6.174-10.945-6.174a19.391 19.391 0 00-5.65 1.992c.768 2.585 2.172 8.888-.3 18l16.793.126h.208l16.294-.126c-2.495-9.183-1.048-15.526-.284-18.064z"
            transform="translate(-268.82 -139.87)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g data-name="Group 106360">
        <g
          data-name="Ellipse 129810"
          transform="translate(-3696 -12966) translate(3696 12966)"
          fill="#fbecec"
          stroke="#d5ccff"
          strokeWidth={3}
        >
          <circle cx={37.5} cy={37.5} r={37.5} stroke="none" />
          <circle cx={37.5} cy={37.5} r={36} fill="none" />
        </g>
        <g
          data-name="Group 106184"
          transform="translate(-3696 -12966) translate(3481 12966.99)"
          clipPath="url(#a)"
        >
          <g data-name="Group 106183">
            <g data-name="Group 106171">
              <g data-name="Group 106167">
                <g data-name="Group 106162" fill="#723021">
                  <g data-name="Group 106160">
                    <path
                      data-name="Path 99326"
                      d="M253.466 35.706s-.962 11.764-6.408 18.028c-6.07 6.982-3.13 18.376 7.079 17.97a87.829 87.829 0 0115.109.682l9.936-48.734s-11.028-6.4-20.418 1.5l-5.3 10.561z"
                      transform="translate(226.682 8.661) translate(-242.74 -21.205)"
                    />
                    <path
                      data-name="Path 99327"
                      d="M258.436 33.817c-.941 1.73-1.913 3.443-2.875 5.162s-1.953 3.421-2.929 5.133l.036-.1c-.14.93-.319 1.838-.521 2.746-.1.452-.212.9-.319 1.357s-.237.9-.37 1.346-.262.894-.406 1.335l-.445 1.325-.488 1.31c-.176.434-.363.858-.546 1.289s-.4.844-.6 1.267-.427.833-.653 1.242l-.341.614c-.118.2-.251.4-.377.6-.262.391-.488.8-.786 1.17s-.556.761-.872 1.116L245 61.763a13.136 13.136 0 00-1.7 2.093 11.882 11.882 0 00-1.221 2.387 12.234 12.234 0 00-.668 2.6 11.386 11.386 0 00-.065 2.685 9.911 9.911 0 00.621 2.613 8.713 8.713 0 003.335 4.143 9.277 9.277 0 002.47 1.149 13.782 13.782 0 002.714.485 12.378 12.378 0 01-2.761-.312 9.507 9.507 0 01-2.6-1.045 8.423 8.423 0 01-2.165-1.806 9.325 9.325 0 01-1.493-2.409 10.888 10.888 0 01-.754-5.586 12.713 12.713 0 011.921-5.324 14.131 14.131 0 011.777-2.215l.915-1.012c.3-.337.549-.718.829-1.073s.51-.75.761-1.124c.122-.19.251-.377.366-.574l.334-.6c.223-.4.452-.79.643-1.206s.413-.811.589-1.235l.542-1.26.5-1.278.46-1.3c.147-.434.28-.872.42-1.31a49.957 49.957 0 001.339-5.334l.011-.061.025-.039c1.037-1.673 2.057-3.36 3.112-5.022s2.093-3.338 3.166-4.99z"
                      transform="translate(226.682 8.661) translate(-240.631 -29.285)"
                    />
                  </g>
                  <g data-name="Group 106161">
                    <path
                      data-name="Path 99328"
                      d="M316.207 35.706s.962 11.764 6.408 18.028c6.07 6.982 3.13 18.376-7.079 17.97a87.829 87.829 0 00-15.109.682l-9.937-48.735s11.028-6.4 20.418 1.5l5.3 10.561z"
                      transform="translate(226.682 8.661) translate(17.898) translate(-290.49 -21.205)"
                    />
                    <path
                      data-name="Path 99329"
                      d="M342.41 33.83c1.073 1.651 2.114 3.324 3.166 4.99s2.075 3.349 3.112 5.022l.025.039.011.061a50.767 50.767 0 001.339 5.331c.14.438.273.876.42 1.31l.46 1.3.5 1.278.542 1.26c.176.424.395.822.589 1.235s.42.808.643 1.206l.334.6c.115.194.244.381.366.574.251.377.477.775.761 1.124s.531.736.829 1.073l.915 1.012a14.342 14.342 0 011.777 2.215 12.713 12.713 0 011.921 5.324 10.888 10.888 0 01-.754 5.586 9.229 9.229 0 01-1.493 2.409 8.423 8.423 0 01-2.165 1.806 9.507 9.507 0 01-2.6 1.045 12.378 12.378 0 01-2.76.312 13.524 13.524 0 002.714-.485 9.174 9.174 0 002.47-1.149 8.712 8.712 0 003.335-4.143 9.912 9.912 0 00.621-2.613 11.392 11.392 0 00-.065-2.685 12.153 12.153 0 00-1.888-4.986 13.3 13.3 0 00-1.7-2.093l-.948-1.037c-.312-.355-.578-.743-.869-1.116a13.317 13.317 0 01-.786-1.17c-.126-.2-.258-.395-.377-.6l-.341-.614c-.226-.409-.46-.818-.653-1.242s-.42-.836-.6-1.267-.37-.858-.546-1.289l-.488-1.31-.445-1.325c-.144-.442-.269-.89-.406-1.335s-.248-.9-.37-1.346-.219-.9-.319-1.357c-.2-.908-.377-1.816-.521-2.746l.036.1c-.973-1.712-1.971-3.41-2.929-5.133s-1.931-3.432-2.872-5.162z"
                      transform="translate(226.682 8.661) translate(17.898) translate(-323.772 -29.298)"
                    />
                  </g>
                </g>
                <g data-name="Group 106163">
                  <path
                    data-name="Path 99330"
                    d="M281.056 112.806c-2.369-1.942-.169-13.056-.169-13.056h-13.425s2.2 11.117-.169 13.056-17.927 1.705-16.5 21.258h45.658c1.766-19.6-13.024-19.316-15.393-21.258z"
                    transform="translate(226.682 8.661) translate(3.615 28.196) translate(-250.702 -99.75)"
                    fill="#ffb899"
                  />
                  <path
                    data-name="Path 99331"
                    d="M310.292 111.7c-1.17-3.421.513-11.947.513-11.947H297.38a53.233 53.233 0 01.926 8.378 19.661 19.661 0 0011.983 3.568z"
                    transform="translate(226.682 8.661) translate(3.615 28.196) translate(-280.624 -99.75)"
                    fill="#efa084"
                  />
                </g>
                <g data-name="Group 106166">
                  <g data-name="Group 106164">
                    <path
                      data-name="Path 99332"
                      d="M274.134 79.2c.657 2.409 2.513 4.545 3.97 4.146s1.967-3.181 1.307-5.589-2.236-3.532-3.69-3.134-2.244 2.168-1.583 4.577z"
                      transform="translate(226.682 8.661) translate(10.579 1.001) translate(1.364 4.368) translate(-273.902 -60.763)"
                      fill="#efa084"
                    />
                    <path
                      data-name="Path 99333"
                      d="M347.288 79.2c-.657 2.409-2.513 4.545-3.97 4.146s-1.967-3.181-1.307-5.589 2.236-3.532 3.69-3.134 2.244 2.168 1.583 4.577z"
                      transform="translate(226.682 8.661) translate(10.579 1.001) translate(1.364 4.368) translate(-317.379 -60.763)"
                      fill="#efa084"
                    />
                    <path
                      data-name="Path 99334"
                      d="M282.22 50.275c0 8.82 5.449 17.823 12.176 17.823s12.176-9 12.176-17.823S301.124 36.16 294.4 36.16s-12.176 5.3-12.176 14.115z"
                      transform="translate(226.682 8.661) translate(10.579 1.001) translate(1.364 4.368) translate(-279.234 -36.16)"
                      fill="#ffb899"
                    />
                  </g>
                  <g data-name="Group 106165" fill="#723021">
                    <path
                      data-name="Path 99335"
                      d="M329.772 34.147c-2.043-8.576-13.339-14.294-17.015-6.4 0 0-2 11.76 11.164 16.333.025 1.978.355 4.9 1.224 5.173l.739-3.7.079.022.409-2.452.162-.815a2.466 2.466 0 012.286 2.592s2.778-3.091.951-10.755z"
                      transform="translate(226.682 8.661) translate(10.579 1.001) translate(-297.375 -23.993)"
                    />
                    <path
                      data-name="Path 99336"
                      d="M270.794 34.147c2.043-8.576 12.93-14.294 16.606-6.4 0 0 1.583 12.033-11.581 16.606-.025 1.978.065 4.631-.808 4.9l-.739-3.7-.079.022-.409-2.452-.162-.815a2.466 2.466 0 00-2.287 2.585s-2.369-3.091-.542-10.755z"
                      transform="translate(226.682 8.661) translate(10.579 1.001) translate(-270.102 -23.993)"
                    />
                    <path
                      data-name="Path 99337"
                      d="M287.911 56.1c.309-.111.61-.244.908-.381s.592-.276.883-.427a16.4 16.4 0 001.676-1c.269-.179.535-.366.793-.56s.51-.4.754-.607.481-.427.714-.65.452-.456.664-.7a11.945 11.945 0 002.06-3.2c.129-.291.241-.589.348-.887s.2-.6.269-.912.14-.617.2-.933.079-.632.126-.944l.485-3.231.327 3.231c.029.284.083.6.14.9s.133.6.212.9a16.928 16.928 0 00.592 1.763c.115.287.241.571.373.851s.276.556.431.822.32.528.488.79l.262.384.28.37a8.7 8.7 0 00.607.7c.208.23.434.442.657.657s.463.416.718.6c.244.2.506.363.765.538s.531.334.811.477.56.287.851.406.589.23.887.341.607.19.908.291c-.312-.057-.632-.1-.944-.172s-.625-.151-.926-.258-.607-.212-.908-.334-.589-.266-.879-.413-.567-.316-.836-.5-.531-.377-.793-.574-.5-.42-.732-.65-.456-.467-.675-.711l-.316-.377-.3-.391c-.194-.266-.377-.535-.546-.815s-.33-.564-.481-.854-.291-.585-.42-.883a14.065 14.065 0 01-.65-1.845c-.086-.316-.169-.632-.233-.951s-.126-.635-.165-.987h.811c-.043.337-.075.675-.14 1.009s-.126.668-.219.994-.19.653-.3.973-.237.635-.384.944a11.982 11.982 0 01-2.3 3.321c-.233.244-.481.47-.729.7s-.51.438-.779.635-.538.395-.822.574-.564.355-.854.521a16.4 16.4 0 01-1.795.854 11.644 11.644 0 01-1.885.607z"
                      transform="translate(226.682 8.661) translate(10.579 1.001) translate(-281.511 -35.325)"
                    />
                  </g>
                </g>
              </g>
              <g data-name="Group 106170">
                <g data-name="Group 106168" fill="#f77b59">
                  <path
                    data-name="Path 99338"
                    d="M275.292 81.146a4.128 4.128 0 01.025-.941 2.265 2.265 0 01.111-.474.943.943 0 01.309-.459.542.542 0 01.334-.093.727.727 0 01.305.093 1.237 1.237 0 01.129.083.843.843 0 01.093.079 1.377 1.377 0 01.183.219 3.689 3.689 0 01.424.894 10.05 10.05 0 01.409 1.845 16.219 16.219 0 01.147 1.867v.111l-.079.05a1.949 1.949 0 00-.223.172.95.95 0 00-.172.212.353.353 0 00.032.445 1.428 1.428 0 00.492.33 5.576 5.576 0 00.592.223 3.916 3.916 0 01-.635-.108 1.434 1.434 0 01-.6-.294.628.628 0 01-.2-.334.685.685 0 01.057-.391 1.392 1.392 0 01.2-.305 1.855 1.855 0 01.255-.248l-.079.162c-.086-.6-.183-1.213-.291-1.813-.05-.3-.108-.6-.176-.894a8.607 8.607 0 00-.219-.872 3.588 3.588 0 00-.319-.8 2.983 2.983 0 00-.1-.147.5.5 0 00-.075-.079c0-.007-.043-.032-.061-.05-.1-.065-.158-.083-.233-.047a.646.646 0 00-.233.273 3.205 3.205 0 00-.172.406 8.738 8.738 0 00-.237.89z"
                    transform="translate(226.682 8.661) translate(12.437 17.11) translate(0 3.693) translate(-275.277 -79.17)"
                  />
                  <path
                    data-name="Path 99339"
                    d="M350.853 81.133a7.9 7.9 0 00-.237-.89 3.2 3.2 0 00-.172-.406.669.669 0 00-.233-.273c-.072-.032-.133-.018-.233.047-.018.018-.057.039-.061.05a.5.5 0 00-.075.079 2.03 2.03 0 00-.1.147 3.77 3.77 0 00-.319.8c-.086.284-.158.578-.219.872s-.126.592-.176.894c-.108.6-.2 1.206-.291 1.813l-.079-.162a1.855 1.855 0 01.255.248 1.392 1.392 0 01.2.305.68.68 0 01.057.391.642.642 0 01-.2.334 1.476 1.476 0 01-.6.294 3.851 3.851 0 01-.635.108 5.294 5.294 0 00.592-.223 1.48 1.48 0 00.492-.33.358.358 0 00.032-.445.95.95 0 00-.172-.212 1.377 1.377 0 00-.223-.172l-.079-.05v-.111a16.288 16.288 0 01.151-1.867 10.824 10.824 0 01.409-1.845 3.619 3.619 0 01.424-.894 1.555 1.555 0 01.183-.219.843.843 0 01.093-.079 1.24 1.24 0 01.129-.083.782.782 0 01.305-.093.535.535 0 01.334.093.959.959 0 01.309.459 2.265 2.265 0 01.111.474 4.131 4.131 0 01.025.941z"
                    transform="translate(226.682 8.661) translate(12.437 17.11) translate(0 3.693) translate(-321.721 -79.157)"
                  />
                </g>
                <g data-name="Group 106169">
                  <path
                    data-name="Path 99340"
                    d="M316.9 85.37c.075.147.14.3.2.449s.14.287.2.431.144.28.2.424l.219.409.23.395c.09.122.169.248.255.373l.273.355c.1.111.2.219.294.334l.273.327-.323.208c-.2.126-.4.237-.6.355s-.409.223-.614.334a9.983 9.983 0 01-1.3.56 9.733 9.733 0 011.027-.976c.183-.147.359-.3.549-.434s.37-.284.564-.413l-.05.535c-.122-.122-.237-.251-.355-.373l-.305-.413c-.086-.147-.172-.294-.251-.445l-.2-.463-.147-.481c-.039-.162-.065-.327-.1-.488s-.032-.334-.047-.5 0-.327.014-.492z"
                    transform="translate(226.682 8.661) translate(12.437 17.11) translate(4.898) translate(-306.414 -79.447)"
                    fill="#f77b59"
                  />
                  <path
                    data-name="Path 99341"
                    d="M306.37 104.94s4.139 4.254 7.958.133"
                    transform="translate(226.682 8.661) translate(12.437 17.11) translate(4.898) translate(-300.106 -91.991)"
                    fill="#fff"
                  />
                  <path
                    data-name="Path 99342"
                    d="M319.394 71.763a.633.633 0 01.025-.111 2.575 2.575 0 01.1-.305 4.179 4.179 0 01.219-.452 3.866 3.866 0 01.373-.538 4.52 4.52 0 01.553-.567c.108-.1.233-.169.355-.258l.19-.129a3.44 3.44 0 01.212-.1 4.521 4.521 0 01.445-.2c.158-.047.32-.093.485-.133a2.358 2.358 0 01.5-.072 4.093 4.093 0 01.513-.022l.506.057c.083.011.169.018.251.036l.237.072a4.2 4.2 0 01.887.337 6.448 6.448 0 01.75.438c.215.169.416.33.592.485a3.114 3.114 0 01.445.459c.126.144.226.276.309.381.165.215.248.348.248.348s-.154-.05-.4-.154c-.122-.054-.273-.115-.438-.194a5.874 5.874 0 00-.553-.244c-.2-.079-.42-.169-.646-.266s-.474-.151-.714-.241a5.389 5.389 0 00-.754-.19l-.19-.047-.194-.014-.384-.036a2.683 2.683 0 00-.38.007 1.885 1.885 0 00-.377.029c-.122.025-.244.043-.37.061s-.237.072-.355.1l-.176.05-.165.072c-.111.047-.223.086-.327.136a5.948 5.948 0 00-.585.323c-.187.1-.345.226-.5.323s-.273.2-.373.287-.187.147-.241.2-.086.072-.086.072z"
                    transform="translate(226.682 8.661) translate(12.437 17.11) translate(4.898) translate(-308.452 -68.869)"
                    fill="#161114"
                  />
                  <path
                    data-name="Path 99343"
                    d="M288.92 71.763a.635.635 0 01.025-.111 2.574 2.574 0 01.1-.305 4.185 4.185 0 01.219-.452 3.864 3.864 0 01.373-.538 4.52 4.52 0 01.553-.567c.108-.1.233-.169.355-.258l.19-.129a3.44 3.44 0 01.212-.1 4.521 4.521 0 01.445-.2 9.51 9.51 0 01.485-.133 2.357 2.357 0 01.5-.072 4.093 4.093 0 01.513-.022l.506.057c.083.011.169.018.251.036l.237.072a4.2 4.2 0 01.887.337 6.449 6.449 0 01.75.438c.215.169.416.33.592.485a3.111 3.111 0 01.445.459c.126.144.226.276.312.381.165.215.248.348.248.348s-.154-.05-.4-.154c-.122-.054-.273-.115-.438-.194a5.874 5.874 0 00-.553-.244c-.2-.079-.42-.169-.646-.266s-.474-.151-.714-.241a5.389 5.389 0 00-.754-.19l-.19-.047-.194-.014-.384-.036a2.683 2.683 0 00-.38.007 1.886 1.886 0 00-.377.029c-.122.025-.244.043-.37.061s-.237.072-.355.1l-.176.05-.165.072c-.111.047-.223.086-.327.136a5.948 5.948 0 00-.585.323c-.187.1-.345.226-.5.323s-.273.2-.373.287-.187.147-.241.2-.086.072-.086.072z"
                    transform="translate(226.682 8.661) translate(12.437 17.11) translate(4.898) translate(-288.92 -68.869)"
                    fill="#161114"
                  />
                  <path
                    data-name="Path 99344"
                    d="M300.925 81.934c0 .958-.266 1.734-.592 1.734s-.592-.775-.592-1.734.266-1.734.592-1.734.592.775.592 1.734z"
                    transform="translate(226.682 8.661) translate(12.437 17.11) translate(4.898) translate(-295.856 -76.132)"
                    fill="#161114"
                  />
                  <path
                    data-name="Path 99345"
                    d="M329.735 81.274c0 .958-.266 1.734-.592 1.734s-.592-.775-.592-1.734.266-1.734.592-1.734.592.775.592 1.734z"
                    transform="translate(226.682 8.661) translate(12.437 17.11) translate(4.898) translate(-314.324 -75.709)"
                    fill="#161114"
                  />
                </g>
              </g>
            </g>
            <g data-name="Group 106182">
              <path
                data-name="Path 99346"
                d="M301.831 141.8a19.006 19.006 0 00-5.169-1.928s-1.978 6.124-10.945 6.174c-8.964-.05-10.945-6.174-10.945-6.174a19.391 19.391 0 00-5.65 1.992c.768 2.585 2.172 8.888-.3 18l16.793.126h.208l16.294-.126c-2.495-9.183-1.048-15.526-.284-18.064z"
                transform="translate(226.682 8.661) translate(10.119 42.598) translate(-268.82 -139.87)"
                fill="#d84848"
              />
              <g
                data-name="Group 106181"
                clipPath="url(#b)"
                transform="translate(226.682 8.661) translate(10.119 42.598)"
              >
                <g data-name="Group 106180" fill="#161114">
                  <g data-name="Group 106172">
                    <path
                      data-name="Path 99347"
                      d="M269.263 212.46a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(-267.82 -187.26)"
                    />
                    <path
                      data-name="Path 99348"
                      d="M269.263 194.91a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(-267.82 -176.01)"
                    />
                    <path
                      data-name="Path 99349"
                      d="M269.263 177.36a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(-267.82 -164.76)"
                    />
                    <path
                      data-name="Path 99350"
                      d="M269.263 159.81a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(-267.82 -153.51)"
                    />
                    <path
                      data-name="Path 99351"
                      d="M269.263 142.26a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(-267.82 -142.26)"
                    />
                  </g>
                  <g
                    data-name="Group 106173"
                    transform="translate(-.359 .858) translate(4.372 3.791)"
                  >
                    <circle
                      data-name="Ellipse 129819"
                      cx={1.443}
                      cy={1.443}
                      r={1.443}
                      transform="translate(0 25.196)"
                    />
                    <circle
                      data-name="Ellipse 129820"
                      cx={1.443}
                      cy={1.443}
                      r={1.443}
                      transform="translate(0 18.9)"
                    />
                    <path
                      data-name="Path 99352"
                      d="M281.443 187.92a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-280 -175.32)"
                    />
                    <circle
                      data-name="Ellipse 129821"
                      cx={1.443}
                      cy={1.443}
                      r={1.443}
                      transform="translate(0 6.3)"
                    />
                    <path
                      data-name="Path 99353"
                      d="M281.443 152.82a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-280 -152.82)"
                    />
                  </g>
                  <g data-name="Group 106174">
                    <path
                      data-name="Path 99354"
                      d="M293.613 212.46a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(8.741) translate(-292.17 -187.26)"
                    />
                    <path
                      data-name="Path 99355"
                      d="M293.613 194.91a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(8.741) translate(-292.17 -176.01)"
                    />
                    <path
                      data-name="Path 99356"
                      d="M293.613 177.36a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(8.741) translate(-292.17 -164.76)"
                    />
                    <path
                      data-name="Path 99357"
                      d="M293.613 159.81a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(8.741) translate(-292.17 -153.51)"
                    />
                    <path
                      data-name="Path 99358"
                      d="M293.613 142.26a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(8.741) translate(-292.17 -142.26)"
                    />
                  </g>
                  <g data-name="Group 106175">
                    <path
                      data-name="Path 99359"
                      d="M305.793 223.02a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(13.113 3.791) translate(-304.35 -197.82)"
                    />
                    <path
                      data-name="Path 99360"
                      d="M305.793 205.47a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(13.113 3.791) translate(-304.35 -186.57)"
                    />
                    <path
                      data-name="Path 99361"
                      d="M305.793 187.92a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(13.113 3.791) translate(-304.35 -175.32)"
                    />
                    <path
                      data-name="Path 99362"
                      d="M305.793 170.37a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(13.113 3.791) translate(-304.35 -164.07)"
                    />
                    <path
                      data-name="Path 99363"
                      d="M305.793 152.82a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(13.113 3.791) translate(-304.35 -152.82)"
                    />
                  </g>
                  <g data-name="Group 106176">
                    <path
                      data-name="Path 99364"
                      d="M318.3 212.46a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(17.604) translate(-316.86 -187.26)"
                    />
                    <path
                      data-name="Path 99365"
                      d="M318.3 194.91a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(17.604) translate(-316.86 -176.01)"
                    />
                    <path
                      data-name="Path 99366"
                      d="M318.3 177.36a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(17.604) translate(-316.86 -164.76)"
                    />
                    <path
                      data-name="Path 99367"
                      d="M318.3 159.81a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(17.604) translate(-316.86 -153.51)"
                    />
                    <path
                      data-name="Path 99368"
                      d="M318.3 142.26a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(17.604) translate(-316.86 -142.26)"
                    />
                  </g>
                  <g data-name="Group 106177">
                    <path
                      data-name="Path 99369"
                      d="M330.473 223.02a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(21.973 3.791) translate(-329.03 -197.82)"
                    />
                    <path
                      data-name="Path 99370"
                      d="M330.473 205.47a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(21.973 3.791) translate(-329.03 -186.57)"
                    />
                    <path
                      data-name="Path 99371"
                      d="M330.473 187.92a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(21.973 3.791) translate(-329.03 -175.32)"
                    />
                    <path
                      data-name="Path 99372"
                      d="M330.473 170.37a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(21.973 3.791) translate(-329.03 -164.07)"
                    />
                    <path
                      data-name="Path 99373"
                      d="M330.473 152.82a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(21.973 3.791) translate(-329.03 -152.82)"
                    />
                  </g>
                  <g
                    data-name="Group 106178"
                    transform="translate(-.359 .858) translate(26.345)"
                  >
                    <path
                      data-name="Path 99374"
                      d="M342.653 212.46a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-341.21 -187.26)"
                    />
                    <path
                      data-name="Path 99375"
                      d="M342.653 194.91a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-341.21 -176.01)"
                    />
                    <path
                      data-name="Path 99376"
                      d="M342.653 177.36a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-341.21 -164.76)"
                    />
                    <path
                      data-name="Path 99377"
                      d="M342.653 159.81a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-341.21 -153.51)"
                    />
                    <circle
                      data-name="Ellipse 129822"
                      cx={1.443}
                      cy={1.443}
                      r={1.443}
                    />
                  </g>
                  <g data-name="Group 106179">
                    <path
                      data-name="Path 99378"
                      d="M354.823 223.02a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(30.714 3.791) translate(-353.38 -197.82)"
                    />
                    <path
                      data-name="Path 99379"
                      d="M354.823 205.47a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(30.714 3.791) translate(-353.38 -186.57)"
                    />
                    <path
                      data-name="Path 99380"
                      d="M354.823 187.92a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(30.714 3.791) translate(-353.38 -175.32)"
                    />
                    <path
                      data-name="Path 99381"
                      d="M354.823 170.37a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(30.714 3.791) translate(-353.38 -164.07)"
                    />
                    <path
                      data-name="Path 99382"
                      d="M354.823 152.82a1.443 1.443 0 11-1.443 1.443 1.443 1.443 0 011.443-1.443z"
                      transform="translate(-.359 .858) translate(30.714 3.791) translate(-353.38 -152.82)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function CalmIllustration(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 60,
    height: 60,
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
      sx={rootSx}
      {...rest}
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Path 99406"
            d="M28.442 273.734a25.2 25.2 0 01-17.717-7.288 22.07 22.07 0 01-6.254-11.28 25.308 25.308 0 01.562-13.084 26.222 26.222 0 016.813-11.2 23.863 23.863 0 0116.595-7.127q9.542-.233 17.394 7.443a25.144 25.144 0 018.019 17.702 22.62 22.62 0 01-7.214 17.55 24.318 24.318 0 01-18.2 7.285z"
            fill="none"
          />
        </clipPath>
      </defs>
      <g data-name="Group 106363">
        <g
          data-name="Ellipse 129812"
          transform="translate(-3513 -12981) translate(3513 12981)"
          fill="#e1f0ff"
          stroke="#eae6ff"
          strokeWidth={3}
        >
          <circle cx={30} cy={30} r={30} stroke="none" />
          <circle cx={30} cy={30} r={28.5} fill="none" />
        </g>
        <g
          data-name="Group 106200"
          transform="translate(-3513 -12981) translate(3514.133 12764.256)"
          clipPath="url(#a)"
        >
          <g data-name="Group 106199">
            <g data-name="Group 106193">
              <g data-name="Group 106187" fill="#db5223">
                <g data-name="Group 106185">
                  <path
                    data-name="Path 99385"
                    d="M54.984 256.066s-4.437-1.932-6.729 5.153-4.224 16.75 1.647 19.542l-.429-1.718s.5 1.574 3.437 2.147 7.087 1 7.087 1l-5.011-26.126z"
                    transform="translate(10.684 229.227) translate(0 2.96) translate(3.622) translate(-45.364 -255.826)"
                  />
                  <path
                    data-name="Path 99386"
                    d="M53.268 257.328a2.1 2.1 0 00-.326-.111 3.959 3.959 0 00-.958-.147 4.5 4.5 0 00-.689.026 4.375 4.375 0 00-.787.192 4.769 4.769 0 00-.834.382 5.545 5.545 0 00-.808.618l-.2.182-.1.092-.089.105c-.118.142-.239.287-.363.432a3.988 3.988 0 00-.337.479c-.108.166-.224.332-.329.508-.182.368-.395.732-.563 1.126s-.337.8-.489 1.224a56.272 56.272 0 00-1.661 5.382 30.107 30.107 0 00-.934 5.537 17.061 17.061 0 00.029 2.576 9.97 9.97 0 00.466 2.255 7.38 7.38 0 00.853 1.745 6.173 6.173 0 001.005 1.118 5.729 5.729 0 00.784.576l.295.182-.3-.168a5.255 5.255 0 01-.811-.547 6.181 6.181 0 01-1.055-1.1 7.027 7.027 0 01-.918-1.753 12.6 12.6 0 01-.589-4.9 30.02 30.02 0 01.905-5.592c.479-1.868 1.084-3.7 1.705-5.395.158-.424.342-.834.511-1.237s.405-.766.595-1.134c.111-.176.232-.345.345-.513a4.374 4.374 0 01.355-.482c.129-.147.258-.292.382-.437l.095-.105.105-.092c.071-.061.139-.124.208-.184a5.323 5.323 0 01.845-.618 4.85 4.85 0 01.871-.366 4.258 4.258 0 01.811-.171 4.485 4.485 0 01.7 0 3.724 3.724 0 01.961.187 1.968 1.968 0 01.321.126z"
                    transform="translate(10.684 229.227) translate(0 2.96) translate(3.622) translate(-43.532 -256.69)"
                  />
                </g>
                <g data-name="Group 106186">
                  <path
                    data-name="Path 99387"
                    d="M106.083 256.066s4.437-1.932 6.729 5.153 4.224 16.75-1.647 19.542l.429-1.718s-.5 1.574-3.437 2.147-7.087 1-7.087 1l5.011-26.126z"
                    transform="translate(10.684 229.227) translate(0 2.96) translate(3.622) translate(15.142) translate(-101.07 -255.826)"
                  />
                  <path
                    data-name="Path 99388"
                    d="M119.68 257.335a2.115 2.115 0 01.321-.126 3.725 3.725 0 01.961-.187 4.485 4.485 0 01.7 0 4.3 4.3 0 01.811.171 4.742 4.742 0 01.871.366 5.321 5.321 0 01.845.618l.208.184.105.092.095.105c.126.142.253.289.382.437a4.373 4.373 0 01.355.482c.113.168.234.334.345.513.192.368.416.737.595 1.134s.353.813.511 1.237c.621 1.695 1.226 3.526 1.705 5.395a30.238 30.238 0 01.905 5.592 12.6 12.6 0 01-.589 4.9 6.936 6.936 0 01-.918 1.753 6.274 6.274 0 01-1.055 1.1 5.458 5.458 0 01-.811.547l-.3.168.295-.182a5.9 5.9 0 00.784-.576 6.174 6.174 0 001.005-1.118 7.38 7.38 0 00.853-1.745 10.116 10.116 0 00.466-2.255 17.066 17.066 0 00.029-2.576 29.887 29.887 0 00-.934-5.537 56.27 56.27 0 00-1.661-5.382c-.153-.421-.334-.821-.489-1.224s-.382-.758-.563-1.126c-.105-.176-.221-.339-.329-.508a3.989 3.989 0 00-.337-.479l-.363-.432-.089-.105-.1-.092-.2-.182a5.545 5.545 0 00-.808-.618 4.769 4.769 0 00-.834-.382 4.324 4.324 0 00-.787-.192 4.5 4.5 0 00-.689-.026 3.831 3.831 0 00-.958.147 1.975 1.975 0 00-.326.111z"
                    transform="translate(10.684 229.227) translate(0 2.96) translate(3.622) translate(15.142) translate(-114.783 -256.697)"
                  />
                </g>
              </g>
              <g data-name="Group 106192">
                <g data-name="Group 106189">
                  <path
                    data-name="Path 99389"
                    d="M57.247 331.875c-1.661-1.361-.118-9.155-.118-9.155h-9.414s1.542 7.795-.118 9.155-12.571 1.2-11.568 14.905h32.01c1.237-13.745-9.132-13.545-10.792-14.905z"
                    transform="translate(10.684 229.227) translate(0 2.96) translate(0 17.604) translate(1.63) translate(-35.963 -322.72)"
                    fill="#ffb899"
                  />
                  <g data-name="Group 106188" fill="#efa084">
                    <path
                      data-name="Path 99390"
                      d="M89.673 331.1c-.821-2.4.361-8.376.361-8.376H80.62a37.359 37.359 0 01.65 5.874 13.786 13.786 0 008.403 2.502z"
                      transform="translate(10.684 229.227) translate(0 2.96) translate(0 17.604) translate(1.63) translate(.047) translate(-68.915 -322.72)"
                    />
                    <path
                      data-name="Path 99391"
                      d="M55.085 386.963c-6.016 0-12.058-.147-18.084-.116a14.086 14.086 0 00-.861 4.095 57.567 57.567 0 0032.121.305 14.928 14.928 0 00-.7-4.284H55.082z"
                      transform="translate(10.684 229.227) translate(0 2.96) translate(0 17.604) translate(1.63) translate(.047) translate(-36.14 -369.969)"
                    />
                  </g>
                </g>
                <g data-name="Group 106191" fill="#86c1e2">
                  <path
                    data-name="Path 99392"
                    d="M76.427 362.45a13.2 13.2 0 00-3.627-1.35s-1.387 4.295-7.674 4.329c-6.287-.034-7.674-4.329-7.674-4.329a13.7 13.7 0 00-3.963 1.4 22.845 22.845 0 01-.211 12.616l11.774.089h.148l11.424-.087a22.791 22.791 0 01-.2-12.663z"
                    transform="translate(10.684 229.227) translate(0 2.96) translate(0 17.604) translate(0 10.086) translate(-47.093 -361.086)"
                  />
                  <g data-name="Group 106190">
                    <path
                      data-name="Path 99393"
                      d="M39.362 367.6l.771-6.539s-6.568-.689-10.363 8.471a16.149 16.149 0 008.805 3.221z"
                      transform="translate(10.684 229.227) translate(0 2.96) translate(0 17.604) translate(0 10.086) translate(-29.77 -361.045)"
                    />
                    <path
                      data-name="Path 99394"
                      d="M128.461 367.6l-.771-6.539s6.568-.689 10.363 8.471a16.149 16.149 0 01-8.805 3.221z"
                      transform="translate(10.684 229.227) translate(0 2.96) translate(0 17.604) translate(0 10.086) translate(-101.922 -361.045)"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g data-name="Group 106198">
              <g data-name="Group 106196">
                <g data-name="Group 106194">
                  <path
                    data-name="Path 99395"
                    d="M58.308 301.874c.461 1.689 1.761 3.187 2.782 2.908s1.379-2.229.916-3.918-1.566-2.476-2.589-2.2-1.574 1.521-1.111 3.208z"
                    transform="translate(10.684 229.227) translate(7.03) translate(.436 4.558) translate(-58.14 -288.95)"
                    fill="#efa084"
                  />
                  <path
                    data-name="Path 99396"
                    d="M126.928 301.874c-.461 1.689-1.761 3.187-2.782 2.908s-1.379-2.229-.916-3.918 1.566-2.476 2.589-2.2 1.574 1.521 1.111 3.208z"
                    transform="translate(10.684 229.227) translate(7.03) translate(.436 4.558) translate(-105.955 -288.95)"
                    fill="#efa084"
                  />
                  <path
                    data-name="Path 99397"
                    d="M66.12 271.8c0 6.184 3.821 12.495 8.537 12.495s8.537-6.311 8.537-12.495-3.821-9.9-8.537-9.9-8.537 3.713-8.537 9.9z"
                    transform="translate(10.684 229.227) translate(7.03) translate(.436 4.558) translate(-64.02 -261.9)"
                    fill="#ffb899"
                  />
                </g>
                <g data-name="Group 106195" fill="#db5223">
                  <path
                    data-name="Path 99398"
                    d="M78.76 251.786s3.795 8.3 11.311 8.805c-4.224-3.15-4.582-5.655-4.582-5.655a13.615 13.615 0 005.942 5.655 6.727 6.727 0 00.429 2.863 10.977 10.977 0 00.858-4.582 1.992 1.992 0 011.574 1.932 10.653 10.653 0 00.287-11.6c-3.411-5.471-18.324-7.732-15.818 2.576z"
                    transform="translate(10.684 229.227) translate(7.03) translate(-72.69 -244.578)"
                  />
                  <path
                    data-name="Path 99399"
                    d="M64.486 256.766a4.751 4.751 0 00-6.3.574 8.156 8.156 0 00.142 10.163s-.429 3.005 1.145 4.224c0 0-1.361-7.229 4.224-10.595s.787-4.366.787-4.366z"
                    transform="translate(10.684 229.227) translate(7.03) translate(-56.484 -252.849)"
                  />
                </g>
              </g>
              <g data-name="Group 106197">
                <path
                  data-name="Path 99400"
                  d="M99.1 308.97c.053.105.1.208.145.316s.1.2.139.3.1.2.145.3l.153.287.163.276c.063.084.118.176.176.263l.192.247.205.234.195.221-.229.15c-.137.089-.279.168-.421.25s-.287.155-.432.234a7.2 7.2 0 01-.911.395 7.03 7.03 0 01.718-.684c.129-.1.253-.211.384-.305s.261-.2.395-.289l-.037.371-.25-.261c-.074-.095-.142-.195-.213-.292s-.124-.205-.179-.311l-.142-.326-.1-.337c-.029-.113-.047-.229-.068-.342s-.024-.234-.034-.347 0-.229.008-.345z"
                  transform="translate(10.684 229.227) translate(7.03) translate(4.22 12.8) translate(-91.752 -304.825)"
                  fill="#f77b59"
                />
                <path
                  data-name="Path 99401"
                  d="M89.21 327.69s.084.058.232.147c.074.047.166.1.268.158s.224.121.35.192.268.137.421.2l.232.1c.079.034.163.058.245.087.163.068.345.092.518.147.089.013.179.029.271.045.045.008.089.016.137.021h.137l.274.018c.089-.008.179-.016.268-.026a2.78 2.78 0 00.518-.095l.126-.029.118-.047c.079-.029.155-.061.232-.089a2.708 2.708 0 00.411-.2 2.872 2.872 0 00.342-.2c.095-.071.182-.129.255-.176.145-.1.232-.15.232-.15s-.055.082-.163.221c-.055.068-.118.155-.2.25a1.878 1.878 0 01-.3.287 1.926 1.926 0 01-.4.3l-.242.137a2.589 2.589 0 01-.126.068l-.139.047a2.452 2.452 0 01-.592.155c-.105.013-.211.029-.316.037l-.318-.008-.161-.008c-.053-.008-.1-.018-.155-.029l-.308-.061c-.1-.026-.195-.063-.292-.095a1.952 1.952 0 01-.276-.111c-.087-.042-.176-.079-.258-.124s-.158-.095-.232-.142a3.7 3.7 0 01-.4-.287 3.438 3.438 0 01-.695-.732z"
                  transform="translate(10.684 229.227) translate(7.03) translate(4.22 12.8) translate(-84.818 -318.618)"
                  fill="#f77b59"
                />
                <path
                  data-name="Path 99402"
                  d="M101.67 295.237a1.29 1.29 0 01.092-.289 2.4 2.4 0 01.153-.316 2.467 2.467 0 01.263-.376 2.727 2.727 0 01.387-.4c.074-.066.163-.118.25-.182l.134-.089c.05-.024.1-.047.147-.074a2.99 2.99 0 01.311-.137c.111-.032.224-.063.339-.092a1.584 1.584 0 01.353-.05 2.749 2.749 0 01.361-.013l.355.042c.058.008.118.013.176.024l.166.05a2.952 2.952 0 01.621.237 4.331 4.331 0 01.526.308c.153.116.289.234.416.342a1.982 1.982 0 01.313.321c.089.1.158.192.218.268.116.15.174.242.174.242s-.108-.037-.282-.111c-.087-.037-.192-.079-.305-.137a4.221 4.221 0 00-.387-.171c-.145-.055-.3-.116-.453-.184s-.332-.105-.5-.168a4 4 0 00-.529-.134l-.134-.032-.134-.01-.271-.026a1.829 1.829 0 00-.268.005 1.44 1.44 0 00-.263.018c-.087.018-.171.029-.258.042s-.166.05-.247.071l-.124.034-.116.05c-.076.034-.155.061-.229.1a4.7 4.7 0 00-.413.226c-.129.076-.239.158-.345.229s-.192.139-.261.2-.132.1-.168.137l-.061.053z"
                  transform="translate(10.684 229.227) translate(7.03) translate(4.22 12.8) translate(-93.999 -293.218)"
                  fill="#161114"
                />
                <path
                  data-name="Path 99403"
                  d="M72.52 295.237a1.29 1.29 0 01.092-.289 2.4 2.4 0 01.153-.316 2.467 2.467 0 01.263-.376 2.727 2.727 0 01.387-.4c.074-.066.163-.118.25-.182l.134-.089c.05-.024.1-.047.147-.074a2.8 2.8 0 01.313-.137c.111-.032.224-.063.339-.092a1.584 1.584 0 01.353-.05 2.749 2.749 0 01.361-.013l.355.042c.058.008.118.013.176.024l.166.05a2.952 2.952 0 01.621.237 4.331 4.331 0 01.526.308c.153.116.289.234.416.342a1.982 1.982 0 01.313.321c.089.1.158.192.218.268.116.15.174.242.174.242s-.108-.037-.282-.111c-.087-.037-.192-.079-.305-.137a4.223 4.223 0 00-.387-.171c-.145-.055-.3-.116-.453-.184s-.332-.105-.5-.168a4 4 0 00-.529-.134l-.134-.032-.134-.01-.271-.026a1.829 1.829 0 00-.268.005 1.44 1.44 0 00-.263.018c-.087.018-.171.029-.258.042s-.166.05-.247.071l-.124.034-.116.05c-.076.034-.155.061-.229.1a4.7 4.7 0 00-.413.226c-.129.076-.239.158-.345.229s-.192.139-.261.2-.132.1-.168.137l-.061.053z"
                  transform="translate(10.684 229.227) translate(7.03) translate(4.22 12.8) translate(-72.52 -293.218)"
                  fill="#161114"
                />
                <path
                  data-name="Path 99404"
                  d="M83.692 305.236c0 .671-.187 1.216-.416 1.216s-.416-.545-.416-1.216.187-1.216.416-1.216.416.545.416 1.216z"
                  transform="translate(10.684 229.227) translate(7.03) translate(4.22 12.8) translate(-80.139 -301.177)"
                  fill="#161114"
                />
                <path
                  data-name="Path 99405"
                  d="M111.252 304.606c0 .671-.187 1.216-.416 1.216s-.416-.545-.416-1.216.187-1.216.416-1.216.416.545.416 1.216z"
                  transform="translate(10.684 229.227) translate(7.03) translate(4.22 12.8) translate(-100.446 -300.713)"
                  fill="#161114"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function EnduranceIllustration(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 60,
    height: 60,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
      sx={rootSx}
      {...rest}
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Path 99423"
            d="M270.457 249.113a26.145 26.145 0 01-7.555 18.369 22.88 22.88 0 01-11.7 6.486 26.264 26.264 0 01-13.567-.583 27.169 27.169 0 01-11.617-7.066 24.753 24.753 0 01-7.391-17.206q-.241-9.895 7.716-18.037a26.062 26.062 0 0118.36-8.313 23.464 23.464 0 0118.2 7.479 25.216 25.216 0 017.555 18.869z"
            transform="translate(-.922 -.922)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g data-name="Group 106361">
        <g
          data-name="Ellipse 129811"
          transform="translate(-3752 -12981) translate(3752 12981)"
          fill="#f2f7da"
          stroke="#eae6ff"
          strokeWidth={3}
        >
          <circle cx={30} cy={30} r={30} stroke="none" />
          <circle cx={30} cy={30} r={28.5} fill="none" />
        </g>
        <g
          data-name="Group 106212"
          transform="translate(-3752 -12981) translate(3538 12764.99)"
          clipPath="url(#a)"
        >
          <g data-name="Group 106211">
            <g data-name="Group 106202">
              <g data-name="Group 106201">
                <path
                  data-name="Path 99407"
                  d="M273.764 349.008c-1.547-1.32-.109-8.888-.109-8.888h-8.768s1.438 7.568-.109 8.888-13.263 1.2-12.156 13.932h33.3c1.1-12.732-10.609-12.612-12.156-13.932z"
                  transform="translate(227.098 224.087) translate(0 29.227) translate(.359) translate(-252.547 -340.12)"
                  fill="#8e3e30"
                />
                <path
                  data-name="Path 99408"
                  d="M308.362 348.253c-.766-2.331.336-8.133.336-8.133h-8.768a37.793 37.793 0 01.607 5.7 12.477 12.477 0 007.825 2.433z"
                  transform="translate(227.098 224.087) translate(0 29.227) translate(.359) translate(-287.591 -340.12)"
                  fill="#723021"
                />
              </g>
              <path
                data-name="Path 99409"
                d="M275.106 375.64s-1.24 4.169-6.854 4.2c-5.615-.034-6.854-4.2-6.854-4.2-12.708 3-9.984 13.573-9.984 13.573l16.773.12h.13l16.773-.12s2.725-10.57-9.984-13.573z"
                transform="translate(227.098 224.087) translate(0 29.227) translate(-251.168 -366.39)"
                fill="#c1db4d"
              />
            </g>
            <g data-name="Group 106210">
              <g data-name="Group 106206">
                <g
                  data-name="Group 106203"
                  transform="translate(227.098 224.087) translate(6.822) translate(.599)"
                >
                  <path
                    data-name="Path 99410"
                    d="M285.26 238.918s-4.01.651-3.974-1.018 3.813-.8 3.813-.8-6.581-.557-5.258-3.815 4.1-3.151 6.88.229-4.839-3.859-2.042-5.143 3.49 5.375 3.49 5.375-1.693-6.237 2.391-5.836 3.5 5.167 1.719 6.935.964-4.187 2.617-3.943-2.026 4.466-2.026 4.466 2.068-2.932 4.076-.576-1.354 4.859-4.977 3.792a10.465 10.465 0 00-6.706.339z"
                    transform="translate(-279.665 -227.889)"
                    fill="#161114"
                  />
                  <ellipse
                    data-name="Ellipse 129823"
                    cx={2.641}
                    cy={1.911}
                    rx={2.641}
                    ry={1.911}
                    transform="translate(6.496 8.388)"
                    fill="#c1db4d"
                  />
                </g>
                <g data-name="Group 106205">
                  <g data-name="Group 106204">
                    <path
                      data-name="Path 99411"
                      d="M277.525 317.5c.448 1.641 1.708 3.094 2.7 2.823s1.339-2.164.891-3.8-1.521-2.4-2.513-2.133-1.526 1.474-1.078 3.11z"
                      transform="translate(227.098 224.087) translate(6.822) translate(0 9.818) translate(0 3.313) translate(-277.365 -304.953)"
                      fill="#723021"
                    />
                    <path
                      data-name="Path 99412"
                      d="M344.8 317.5c-.448 1.641-1.708 3.094-2.7 2.823s-1.339-2.164-.891-3.8 1.521-2.4 2.513-2.133 1.529 1.474 1.078 3.11z"
                      transform="translate(227.098 224.087) translate(6.822) translate(0 9.818) translate(0 3.313) translate(-324.443 -304.953)"
                      fill="#723021"
                    />
                    <path
                      data-name="Path 99413"
                      d="M285.18 287.919c0 6 3.711 12.13 8.289 12.13s8.289-6.128 8.289-12.13-3.711-9.609-8.289-9.609-8.289 3.607-8.289 9.609z"
                      transform="translate(227.098 224.087) translate(6.822) translate(0 9.818) translate(0 3.313) translate(-283.145 -278.31)"
                      fill="#8e3e30"
                    />
                  </g>
                  <path
                    data-name="Path 99414"
                    d="M295.718 267.7s-6.88-4.518-12.51-.346c-6.005 3.612-2.224 11.049-2.224 11.049l.417 1.945a11.662 11.662 0 001.086-4.362c1.333-.984 1.555-3.479 1.573-4.823 2.385-.948 6.885-2.18 10.755-.081.01 1.424.245 4.3 1.906 5.1a9.111 9.111 0 00.943 3.883l.112-1.667s4.167-7.128-2.06-10.7z"
                    transform="translate(227.098 224.087) translate(6.822) translate(0 9.818) translate(-279.172 -265.589)"
                    fill="#2c2429"
                  />
                </g>
              </g>
              <g data-name="Group 106209">
                <g data-name="Group 106207" fill="#5e1d12">
                  <path
                    data-name="Path 99415"
                    d="M278.627 319.838a2.569 2.569 0 01-.016-.648 1.537 1.537 0 01.065-.333.693.693 0 01.224-.344.409.409 0 01.266-.076.552.552 0 01.234.068.589.589 0 01.1.063.518.518 0 01.068.055 1.01 1.01 0 01.138.159 2.547 2.547 0 01.3.622c.07.211.125.422.174.63s.078.424.107.635.044.424.06.638.016.424.018.641v.117l-.078.042a.519.519 0 00-.073.049c-.026.018-.049.039-.073.057a.651.651 0 00-.115.13.2.2 0 00.005.258.975.975 0 00.318.232c.128.063.26.117.4.169a2.519 2.519 0 01-.437-.057.967.967 0 01-.43-.2.469.469 0 01-.151-.245.5.5 0 01.039-.292.994.994 0 01.138-.221c.026-.031.055-.062.083-.094a1.068 1.068 0 01.1-.086l-.076.161-.107-.615-.112-.612c-.036-.2-.076-.406-.122-.6s-.086-.4-.143-.589a2.627 2.627 0 00-.2-.529c-.023-.036-.044-.068-.055-.089a.3.3 0 00-.049-.052c.005 0-.021-.018-.031-.029-.06-.039-.065-.044-.094-.039a.373.373 0 00-.148.156 1.923 1.923 0 00-.125.266c-.073.19-.135.393-.193.6z"
                    transform="translate(227.098 224.087) translate(6.822) translate(.321 19.973) translate(0 3.607) translate(-278.598 -318.435)"
                  />
                  <path
                    data-name="Path 99416"
                    d="M348.807 319.839a7.391 7.391 0 00-.193-.6 2.79 2.79 0 00-.125-.266.358.358 0 00-.148-.156c-.031-.005-.034 0-.094.039-.01.01-.036.029-.031.029-.016.018-.044.042-.049.052s-.034.052-.055.089a2.48 2.48 0 00-.2.529c-.057.19-.1.388-.143.589s-.086.4-.122.6l-.112.612-.107.615-.076-.161c.039.031.065.057.1.086a.975.975 0 01.083.094.994.994 0 01.138.221.517.517 0 01.039.292.439.439 0 01-.151.245 1 1 0 01-.43.2 2.8 2.8 0 01-.437.057 3.9 3.9 0 00.4-.169.966.966 0 00.318-.232.2.2 0 00.005-.258.653.653 0 00-.115-.13.787.787 0 00-.073-.057c-.023-.018-.055-.036-.073-.049l-.078-.042v-.117c0-.216.005-.427.018-.641s.031-.424.06-.638.065-.424.107-.635.1-.422.174-.63a2.456 2.456 0 01.3-.622 1.009 1.009 0 01.138-.159c.029-.029.044-.034.068-.055a.825.825 0 01.1-.062.576.576 0 01.234-.068.429.429 0 01.263.076.682.682 0 01.224.344 1.539 1.539 0 01.065.333 2.569 2.569 0 01-.016.648z"
                    transform="translate(227.098 224.087) translate(6.822) translate(.321 19.973) translate(0 3.607) translate(-328.958 -318.437)"
                  />
                </g>
                <g data-name="Group 106208">
                  <path
                    data-name="Path 99417"
                    d="M316.989 315.21c-.008.393-.005.776.018 1.154.01.188.023.375.049.56a4.648 4.648 0 00.089.544 4.22 4.22 0 00.341 1.018c.039.078.081.156.128.232a2.024 2.024 0 00.146.221 2.085 2.085 0 00.169.206c.055.07.122.13.182.2l.2.216-.227.112c-.273.133-.555.258-.836.38s-.568.237-.859.339c.24-.2.49-.375.74-.552s.505-.349.763-.51l-.029.328c-.081-.062-.169-.12-.247-.19a2.959 2.959 0 01-.221-.221 3 3 0 01-.2-.245 2.831 2.831 0 01-.167-.266 3.411 3.411 0 01-.378-1.174 4.431 4.431 0 01.008-1.2 4.829 4.829 0 01.122-.583 3.223 3.223 0 01.206-.555z"
                    transform="translate(227.098 224.087) translate(6.822) translate(.321 19.973) translate(4.051) translate(-310.599 -312.443)"
                    fill="#5e1d12"
                  />
                  <path
                    data-name="Path 99418"
                    d="M307.17 340.643s3.029 2.349 5.409-.263"
                    transform="translate(227.098 224.087) translate(6.822) translate(.321 19.973) translate(4.051) translate(-303.78 -331.058)"
                    fill="#fff"
                  />
                  <path
                    data-name="Path 99419"
                    d="M322.755 306.44a1.4 1.4 0 01.086-.263 2.739 2.739 0 01.37-.625 2.646 2.646 0 01.813-.685 2.279 2.279 0 01.594-.224 2.228 2.228 0 01.672-.052 2.276 2.276 0 01.654.148 2.434 2.434 0 01.552.3 3 3 0 01.424.37 3.134 3.134 0 01.3.385 2.689 2.689 0 01.2.354 1.806 1.806 0 01.125.286 2.729 2.729 0 01.083.26s-.091-.049-.232-.141-.339-.221-.57-.362c-.112-.076-.24-.143-.365-.216s-.263-.141-.4-.2a3.133 3.133 0 00-.422-.151 2.222 2.222 0 00-.427-.073 1.976 1.976 0 00-.43.008 2.808 2.808 0 00-.43.091 4.536 4.536 0 00-.792.328c-.237.12-.437.24-.583.323s-.232.138-.232.138z"
                    transform="translate(227.098 224.087) translate(6.822) translate(.321 19.973) translate(4.051) translate(-315.303 -304.585)"
                    fill="#161114"
                  />
                  <path
                    data-name="Path 99420"
                    d="M294.154 307.048a1.246 1.246 0 01.016-.279 2.212 2.212 0 01.227-.708 2.1 2.1 0 011.357-1.091 2.317 2.317 0 01.682-.062 2.774 2.774 0 01.648.122 3.314 3.314 0 01.56.247 3.66 3.66 0 011.083.943 2.563 2.563 0 01.182.255c.094.146.141.237.141.237s-.1-.029-.26-.089l-.641-.253c-.258-.1-.549-.216-.852-.318-.078-.021-.154-.044-.229-.07s-.154-.036-.232-.057a3.137 3.137 0 00-.456-.062 1.982 1.982 0 00-.432.013 2.215 2.215 0 00-.406.1 2.708 2.708 0 00-.708.419 5 5 0 00-.49.448l-.185.2z"
                    transform="translate(227.098 224.087) translate(6.822) translate(.321 19.973) translate(4.051) translate(-294.152 -304.82)"
                    fill="#161114"
                  />
                  <path
                    data-name="Path 99421"
                    d="M302.427 316.542c0 .651-.18 1.182-.4 1.182s-.4-.529-.4-1.182.18-1.182.4-1.182.4.529.4 1.182z"
                    transform="translate(227.098 224.087) translate(6.822) translate(.321 19.973) translate(4.051) translate(-299.675 -312.554)"
                    fill="#161114"
                  />
                  <path
                    data-name="Path 99422"
                    d="M329.457 315.932c0 .651-.18 1.182-.4 1.182s-.4-.529-.4-1.182.18-1.182.4-1.182.4.529.4 1.182z"
                    transform="translate(227.098 224.087) translate(6.822) translate(.321 19.973) translate(4.051) translate(-319.666 -312.103)"
                    fill="#161114"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
